import { Component, OnInit, Renderer2, AfterViewInit, Input } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";
import { Router, ActivatedRoute } from "@angular/router";
import { CommonService } from '../../../services/common.service';
import { FileUploader } from "ng2-file-upload";
// import { async } from "@angular/core/testing";
const URL = window["omsubconfig"].backOffice + "/fetchpdf?name=";
@Component({
  selector: "app-order-management",
  templateUrl: "./order-management.component.html",
  styleUrls: ["./order-management.component.css"]
})
export class OrderManagementComponent implements OnInit, AfterViewInit {
  TBO_convenience_fees: number;
  buttonFlag: boolean = true;
  demo: string;
  EditFlag: boolean = true;
  DEPT_DATE: any = "";
  Date2: any = "";
  DEPT_TIME: any = "";
  CurrentDate: any = "";
  get_tbo: any = [];
  flag: boolean;
  booking_ref: any = "";
  booking_details: any = "";
  uploaded_file_name = "";
  booking_details_info: any = [];
  segment_details: any = [];
  Segment_Details: any = [];
  pax_detail: any = [];
  Leg_details: any = [];
  Ticket_details: any = [];
  Leg_detailsArray: any = [];
  Legs_Details: any = {};
  adultsCount: any = 0;
  childsCount: any = 0;
  infantsCount: any = 0;
  passenegerCount: any = 0;
  passanger_details: any = {};
  passanger_details_Array: any = [];
  Charge_Details: any = {};
  Charge_Details_Brakup: any = [];
  Note_details: any = {};
  Note_details_Array: any = [];
  fname: any = "";
  lname: any = "";
  uid: any = "";
  user_details: any = {};
  rpm: any = 0.55;
  JpFees: any = 0;
  totalAmount: any = 0;
  Paxtype: any = "";
  arrayId = "NA";
  TRAVEL_TYPE = "";
  AdultCount = "";
  ChildCount = "";
  InfantCount = "";
  ADULT_BASE_FARE = 0;
  CHILD_BASE_FARE = 0;
  INFANT_BASE_FARE = 0;
  ADULT_FEE_N_TAXES = 0;
  CHILD_FEE_N_TAXES = 0;
  INFANT_FEE_N_TAXES = 0;
  TOTAL_AMOUNT = 0;
  TOTAL_BASE_FARE = 0;
  PROMO_DISCOUNT_AMOUNT = 0;
  TOTAL_FEE_N_TAXES = 0;
  AMOUNT_FOR_EXTRA_MILES = 0;
  GST_ON_ADDITIONAL_MILES = 0;
  DepartureAirport = "";
  ArivalAirport = "";
  pnrNumber = "";
  tripType = "";
  SUPPLIER_NAME = "";
  CABIN_CLASS = "";
  FB_BOOKING_REF_NO = "";
  BOOKING_STATUS = "";
  CRIS_STATUS = "";
  ACCRUAL_STATUS = "";
  TRANSACTION_STATUS = "";
  loader: any = false;
  isPnrUpdated: any = false;
  isReversed: any = false;
  updatePnrDetails: any = {};
  aprovebtn: boolean = true;
  rejectbtn: boolean = true;
  roleID = "";
  fid = "";
  RAC_VIEW = "";
  RAC_ADD = "";
  RAC_EDIT = "";
  RAC_APROVE = "";
  ErrMsg = "";
  Convience_fee_per: any;
  Convience_without_gst: any;
  gst_on_convience: any;
  gst: any;
  AirlinePnrArray: any = [];
  updatedPNR: boolean = false;
  ShowUpdatePnr: boolean = false;
  showContent: boolean = false;
  PnrMsg: any = "";
  Email_ID: any = "";
  IS_EMAIL_SENT: number = 0;
  FIRST_BONUS_MILES: any = 0;
  EARN_MILES: any = 0;
  TIER_BONUS_MILES: any = 0;
  BONUS_MILES: any = 0;
  isPriceChange = null;
  Total_amount_paid: any = 0;
  Onward_Booking_ID: any = "";
  Return_Booking_ID: any;
  ancilaries_details: any = [];
  ANCILARIES_TIER_BONUS_MILES: any;
  paxSegDataDetails: any = [];
  pax_seg_details: any = [];
  ANCILARIES_STATUS = "";
  defaultTwo: any;
  defaultOne: any;
  selectionTab: any;
  updateAncilariesIn: boolean = true;
  updateAncilariesOut: boolean = true;
  refundAncilariesIn: boolean = true;
  refundAncilariesOut: boolean = true;
  seatInbound: any = {};
  mealInbound: any = {};
  baggageInbound: any = {};
  loungeInbound: any = {};
  zcInbound: any = {};
  tiInbound: any = {};
  seatOutbound: any = {};
  mealOutbound: any = {};
  baggageOutbound: any = {};
  loungeOutbound: any = {};
  zcOutbound: any = {};
  tiOutbound: any = {};
  swmUsed: any = {};
  swmBonus: any = {};
  frenzyOffer: any = {};
  genericOfferDiscountTitle: any;
  genericOfferDiscountAmount: any = null;
  flat500Offer: any = {};
  bkg_status_map = {
    "undefined": "Not Opted",
    0: "Pending",
    1: "Pending",
    2: "Confirmed",
    4: "Failed",
    5: "Cancelled",
    6: "Reversed",
    7: "Cancel Requested",
    8: "Cancelled"
  }
  leg_tabs = {};
  current_ancilaries_details: any = [];
  screen_ancill_data = {};
  selectionSeg = 1;
  selectionLeg = 1;
  selectionPax = 1;
  obj = { "0": "travel", "1": "meal", "2": "baggage", "3": "seat", "4": "lounge" }
  update_refund_flag = true;
  custom_header = "";
  custom_msg = "";
  curr_all_disabled = false;
  all_confirm_status = "";
  all_confirm_status_obj = {
    0: false,
    1: false,
    2: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false
  }
  mainScreen = false;

  Onward_Remarks: any;
  Return_Remarks: any;
  public uploader: FileUploader = new FileUploader({
    itemAlias: "photo"
  });
  first_Name: any = "";
  TBO_Return_PNR: any = "";
  TBO_Onward_PNR: string = "";
  TBO_sms: string;
  isTBObooking = false;
  isTravelPortBooking = false;
  transaction_details = [];
  discount_amount = 0;
  TBO_Type: any = "ONEWAY";
  member_category: any = "B2C";
  Onward_fare_type: any = "B2C";
  Return_fare_type: any = "B2C";
  onward_benefits: any = [];
  return_benefits: any = [];
  SUPPLIER_ID: any = "";
  SID: any = "";
  IsOnlySid: boolean = false;
  siderr: any = "";
  isEmtRequired: boolean = false;
  travelPortEMTRequired: any = false;
  historyList: any = [];
  p: number = 1;
  totalItems: number = 1;
  sr_number: number = 0;
  historyLoader: any = false;
  BUNDLE_FARE_AMOUNT: any = 0;
  BUNDLE_FARE_MILES: any = 0;
  paxDiscount: any = 0;
  @Input("supplierIdList") supplierIdList;
  isReturnSupplierSame: boolean = false
  convenineceFees: any = 0;
  convFeesDiscount: any = 0;
  fcAmout: number = 0;
  showFC: boolean = false;
  fCDiscountPrice: number = 0;
  basePriceFCDiscount: number = 0;
  showFCDiscount: boolean = false;
  booking_status = "";
  coms_booking_status = {};
  TI_MILES: number = 0;
  SEAT_MILES: number = 0;
  BAGGAGE_MILES: number = 0;
  MEAL_MILES: number = 0;
  LOUNGE_MILES: number = 0;
  isGrowTreeClicked: boolean = false;
  growTreeAmount: number = 0;
  growTreeDetails = [];
  growTreeMiles: number = 0;
  growTreeCertificateNo: string = '';
  growTreeStatusName: string = '';
  isGrowTreesHidden: boolean = true
  constructor(
    private route: ActivatedRoute,
    private vernostService: VernostServiceService,
    private router: Router,
    private render: Renderer2, private commonService : CommonService
  ) { }

  ngAfterViewInit() {

  }

  ngOnInit() {
    this.onLoad();
    this.travelPortEMTRequired = localStorage.getItem("travelPortEMTRequired");
    this.vernostService.getBenefit().subscribe(resp => {
      resp['data'].forEach(data => {
        var element = Object.assign({}, data);
        this.onward_benefits.push(element);
      })
      resp['data'].forEach(data => {
        var element = Object.assign({}, data);
        this.return_benefits.push(element);
      })
    });
  }

  onLoad() {
    this.uid = localStorage.getItem("uid");
    this.roleID = localStorage.getItem("roleID");
    this.fid = localStorage.getItem("fid");
    var url = "";
    if (this.uid == "" || this.uid == undefined) {
      this.router.navigate(["/login"]);
    }
    var rollArray = {
      funId: this.fid,
      roleID: this.roleID
    };
    this.updatedPNR = false;
    this.isReversed = false;
    this.vernostService.checkFunAccess(rollArray).subscribe(response => {
      this.RAC_VIEW = JSON.stringify(response[0].addinfo[0].RAC_VIEW);
      this.RAC_ADD = JSON.stringify(response[0].addinfo[0].RAC_ADD);
      this.RAC_EDIT = JSON.stringify(response[0].addinfo[0].RAC_EDIT);
      this.RAC_APROVE = JSON.stringify(response[0].addinfo[0].RAC_APROVE);
    });
    // url = "getChargeData";

    // this.vernostService.getDataApi(url).subscribe(response => {
    //   response[0].result.forEach(element => {
    //     if (element.CHARGE_NAME == "JPFEES") {
    //       this.JpFees = parseInt(element.CHARGE_VALUE);
    //     }
    //   });
    // });
    this.updatePnrDetails = {
      AIRLINE_PNR: "",
      TICKET_NUMBER: ""
    };
    this.loader = true;
    this.fname = localStorage.getItem("fname");
    this.lname = localStorage.getItem("lname");
    this.uid = localStorage.getItem("uid");
    var array = {
      parent_table: "mst_user",
      dbFields: [
        "USER_FIRSTNAME",
        "USER_LASTNAME",
        "USER_EMAIL",
        "USER_ADDRESS",
        "USER_MOBILE",
        "ROLE_ID"
      ],
      parent_table_ID: "USER_ID",
      formData: this.uid
    };
    this.vernostService.getData(array).subscribe(response => {
      console.log("getData=========>response", response);

      this.user_details = response[0].result[0];
    });
    this.passanger_details = {
      Paxtype: "Select",
      title: "Select Title",
      firstName: "",
      lastName: "",
      email: "",
      mobile: ""
    };
    this.route.queryParams.subscribe(params => {
      this.booking_ref = params.booking_ref;
    });

    this.getSegmentDetails();
    url = "ticket";
    var Data = {
      ORDER_ID: this.booking_ref
    };
    this.vernostService.postData(url, Data).subscribe(response => {

      console.log("*************::::", response);
      this.booking_status = JSON.stringify(response);
      this.bookingstatusupdate();
      if (response['booking'].length > 0) {
        if (response['booking'][0]['SUPPLIER_NAME'] == 'TBO' && response['booking'][0]['TOTAL_AMOUNT'] == 0) {
          this.mainScreen = false;
          this.booking_details = response["booking"];
          this.isTBObooking = true;
          this.pax_detail = response["booking"];
          this.loader = false;
          this.first_Name = response['booking'][0]['FIRST_NAME'].split(" ")
          console.log("passanger_details.firstName", this.passanger_details.firstName[0]);
          this.passanger_details.firstName = this.first_Name[0];
          this.passanger_details.lastName = this.first_Name[1];
          this.booking_ref = (response['booking'][0]['ORDER_ID'].toString().length < 12 ? "JPUB" + response['booking'][0]['ORDER_ID'] : response['booking'][0]['ORDER_ID'])
        } else {
          if (response['booking'][0]['SUPPLIER_NAME'] == 'TBO') {
            this.isTBObooking = true;
          } else {
            this.isTBObooking = false;
          }
          if (response['booking'][0]['SUPPLIER_NAME'].toUpperCase() == 'TRAVELPORT') {
            this.isTravelPortBooking = true;
          } else {
            this.isTravelPortBooking = false;
          }
          this.mainScreen = true;

          this.pax_seg_details = response['pax_seg_detail'];
          this.booking_details = response["booking"];
          this.growTreeDetails = response['growTree_details']
          this.isGrowTreesHidden = this.growTreeDetails.length ? false : true;
          this.FB_BOOKING_REF_NO = this.booking_details[0].FB_BOOKING_REF_NO;

          this.growTreeAmount = this.growTreeDetails.length ? this.growTreeDetails[0].BOOKING_AMOUNT : 0;
          this.growTreeMiles = this.growTreeDetails.length ? this.growTreeDetails[0].EARN_MILES : 0;
          this.growTreeCertificateNo = this.growTreeDetails.length ? this.growTreeDetails[0].CERTIFICATE_CODE : '';
          this.growTreeStatusName = this.growTreeDetails.length ? this.growTreeDetails[0].STATUS_NAME : ''

          let calculateFCAvailed = (response['freeCancellation_details'].length > 0 ? response['freeCancellation_details'].reduce((a, b) => (a + b.FC_BENEFIT_AMOUNT), 0) : 0);
          console.log("calculateFCAvailed", calculateFCAvailed);

          let calculateFCDiscount = (response['freeCancellation_details'].length > 0 ? response['freeCancellation_details'].reduce((a, b) => (a + b.BASE_PRICE_DISCOUNT), 0) : 0);
          console.log("calculateFCDiscount : ", calculateFCDiscount)


          let totalFcBaseFare = (response['freeCancellation_details'].length > 0 ? response['freeCancellation_details'].reduce((a, b) => (a + b.BASE_PRICE), 0) : 0);
          console.log("totalFcBaseFare", totalFcBaseFare);

          if (response['freeCancellation_details'].length > 0) {
            if (calculateFCAvailed > 0) {
              this.fcAmout = totalFcBaseFare - calculateFCAvailed
            } else {
              this.fcAmout = totalFcBaseFare;
            }

            console.log("totalFcBaseFare 1 : ", totalFcBaseFare)
            this.showFC = true;
          } else {
            this.showFC = false;
          }

          if (response['freeCancellation_details'].length > 0) {
            let basepriceFCDiscount = 0;
            if (calculateFCDiscount > 0) {
              for (let baseprice of response['freeCancellation_details']) {
                if (baseprice.BASE_PRICE) {
                  basepriceFCDiscount += baseprice.BASE_PRICE
                }
              }
              this.basePriceFCDiscount = basepriceFCDiscount
              this.fCDiscountPrice = calculateFCDiscount;
              this.showFCDiscount = true;
              this.showFC = false;
              this.fcAmout = this.fcAmout - this.fCDiscountPrice;
            } else {
              this.showFCDiscount = false
            }
          } else {
            this.showFCDiscount = false
          }



          // this.fcAmout =  (response['freeCancellation_details'].length > 0 ? response['freeCancellation_details'].reduce((a,b)=> (a + b.BASE_PRICE),0) :0);
          this.booking_details_info = response["booking"];


          this.FIRST_BONUS_MILES = this.booking_details_info[0].FIRST_BONUS_MILES;
          this.EARN_MILES = this.booking_details_info[0].EARN_MILES;
          this.TIER_BONUS_MILES = this.booking_details_info[0].TIER_BONUS_MILES;
          this.BONUS_MILES = this.booking_details_info[0].BONUS_MILES;
          this.BUNDLE_FARE_AMOUNT = (this.booking_details_info[0].BUNDLE_FARE_AMOUNT) ? this.booking_details_info[0].BUNDLE_FARE_AMOUNT : 0;
          this.BUNDLE_FARE_MILES = this.booking_details_info[0].BUNDLE_FARE_MILES;
          if ((this.booking_ref.toString().startsWith('IBFA')) || (this.booking_ref.toString().startsWith('IBFS')) || parseInt(this.booking_ref) > 50000000000) {
            this.showContent = true;
          } else {
            this.showContent = false;
          }
          this.BOOKING_STATUS = this.booking_details_info[0].BOOKING_STATUS;
          this.CRIS_STATUS = this.booking_details_info[0].CRIS_STATUS;
          this.ACCRUAL_STATUS = this.booking_details_info[0].ACCRUAL_STATUS;
          this.TRANSACTION_STATUS = this.booking_details_info[0].TRANSACTION_STATUS;
          this.IS_EMAIL_SENT = this.booking_details_info[0].IS_EMAIL_SENT;
          this.segment_details = response["segment_details"];
          this.segment_details.forEach(element => {
            if (element.SUPPLIER_ID != undefined && element.SUPPLIER_ID != null &&
              element.SUPPLIER_ID != "null" && element.SUPPLIER_ID != '' && element.SUPPLIER_ID != '0') {
              element.SUPPLIER_ID = element.SUPPLIER_ID.split("#")[1];
            } else {
              element.SUPPLIER_ID = null;
            }
          });
          if ((this.segment_details.length == 2 && (this.segment_details[0].SUPPLIER_ID == null
            || this.segment_details[1].SUPPLIER_ID == null)) || (this.segment_details.length == 1
              && this.segment_details[0].SUPPLIER_ID == null)) {
            this.supplierIdList = JSON.parse(JSON.stringify(this.segment_details));
            this.SID = "";
          } else {
            this.supplierIdList = [];
            this.SID = this.segment_details[0].SUPPLIER_ID;
          }
          if (this.segment_details.length == 2 && this.segment_details[0].SUPPLIER_CODE == this.segment_details[1].SUPPLIER_CODE
            && this.segment_details[0].SUPPLIER_CODE == "EMT") {
            this.isReturnSupplierSame = true;
          }
          // console.log("BOOKING_STATUS",this.BOOKING_STATUS);
          // console.log("CRIS_STATUS",this.CRIS_STATUS);
          // console.log("TRANSACTION_STATUS",this.TRANSACTION_STATUS);
          if ((this.booking_ref.toString().startsWith('IBFA')) || (this.booking_ref.toString().startsWith('IBFS')) || parseInt(this.booking_ref) > 50000000000) {
            if (this.BOOKING_STATUS == "0" || this.BOOKING_STATUS == "4") {
              if (this.ACCRUAL_STATUS == "2" || this.TRANSACTION_STATUS == "2") {
                this.ShowUpdatePnr = true;
              }
            }
          }
          else {
            if (this.BOOKING_STATUS == "0" || this.BOOKING_STATUS == "4") {
              if (this.CRIS_STATUS == "2" || this.TRANSACTION_STATUS == "2") {
                this.ShowUpdatePnr = true;
              }
            }
          }
          // if(this.booking_details[0].SUPPLIER_ID != undefined && this.booking_details[0].SUPPLIER_ID != null &&
          //   this.booking_details[0].SUPPLIER_ID != "null" && this.booking_details[0].SUPPLIER_ID != ''){
          //   this.SID = this.booking_details[0].SUPPLIER_ID.split("#")[1];
          //   }
          // if(this.SID == "" && this.BOOKING_STATUS == "1"){
          //   this.IsOnlySid = true;
          // }
          // if(this.booking_details[0].SUPPLIER_ID != undefined && this.booking_details[0].SUPPLIER_ID != null &&
          //   this.booking_details[0].SUPPLIER_ID != "null" && this.booking_details[0].SUPPLIER_ID != ''){
          //   this.SID = this.booking_details[0].SUPPLIER_ID.split("#")[1];
          //   }
          this.isEmtRequired = true;
          if (this.booking_details[0].SUPPLIER_NAME == "EaseMyTrip" || this.booking_details[0].SUPPLIER_NAME == "Multi Supplier" || (this.booking_details[0].SUPPLIER_NAME.toUpperCase() == "TRAVELPORT"
            && this.travelPortEMTRequired != undefined && this.travelPortEMTRequired != null && this.travelPortEMTRequired == "true")) {
            this.isEmtRequired = true;
          }
          if (this.SID == "" && (this.BOOKING_STATUS == "2" || this.BOOKING_STATUS == "4" ||
            this.BOOKING_STATUS == "6" || this.BOOKING_STATUS == "7" || this.BOOKING_STATUS == "8"
            || this.BOOKING_STATUS == "11") && this.isEmtRequired) {
            this.IsOnlySid = true;
          }
          console.log(this.isEmtRequired, this.IsOnlySid, "this.SID", this.SID, this.booking_details[0].SUPPLIER_NAME.toUpperCase(), this.travelPortEMTRequired)
          this.Leg_details = response["Leg_details"];
          this.Ticket_details = response["Ticket_details"];
          this.pax_detail = response["pax_detail"];
          this.ancilaries_details = response["ancilaries_details"];
          this.ANCILARIES_TIER_BONUS_MILES = response["ancilaries_tier_bouns_miles"]

          this.transaction_details = response["transaction_details"];
          if (this.transaction_details.length > 0 && this.transaction_details[0].OFFER_DISCOUNT_AMOUNT > 0 && this.transaction_details[0].COBRAND_OFFER_TITLE != '') {
            this.discount_amount = this.transaction_details[0].OFFER_DISCOUNT_AMOUNT;
          }

          this.Leg_details.forEach((element) => {
            this.Date2 = element.DEPT_DATE + ' ' + element.DEPT_TIME;
            console.log("newwwwww date------>>>>>>>>>>", this.Date2);

            this.Date2 = new Date(this.Date2);
            this.CurrentDate = new Date();

            console.log("CurrentDate========>", this.CurrentDate);
            console.log("Date2========>", this.Date2);


            // if (this.CurrentDate > this.Date2) {


            //   //this.EditFlag=false;
            //   element.showEdit = false;
            // }
            // else {


            //   //this.EditFlag=true;
            //   element.showEdit = true;

            // }


          });

          this.openUpdate();

          // console.log("this.pax_detail",this.pax_detail);
          // this.cancellation_per_User_tier = this.getRPM();
          this.calculateFareProduct(this.booking_details[0]);

          setTimeout(() => {
            this.canceled_passenger();
          }, 2000)

          this.loader = false;

          for (var i = 0; i < this.pax_detail.length; i++) {
            if (this.pax_detail[i].PASSENGER_TYPE == "ADT") {
              this.adultsCount = this.adultsCount + 1;
              this.AdultCount = this.adultsCount;
            }
            if (this.pax_detail[i].PASSENGER_TYPE == "CHD") {
              this.childsCount = this.childsCount + 1;
              this.ChildCount = this.childsCount;
            }
            if (this.pax_detail[i].PASSENGER_TYPE == "INF") {
              this.infantsCount = this.infantsCount + 1;
              this.InfantCount = this.infantsCount;
            }
          }
          if (
            this.booking_details[0].GST == undefined ||
            this.booking_details[0].GST == null ||
            this.booking_details[0].GST == 0
          ) {
            this.gst = 18;
          } else {
            this.gst = this.booking_details[0].GST;
          }
          if (
            this.booking_details[0].JP_CHARGE_VALUE == undefined ||
            this.booking_details[0].JP_CHARGE_VALUE == null ||
            this.booking_details[0].JP_CHARGE_VALUE == 0
          ) {
            this.Convience_fee_per = 0;
          } else {
            this.Convience_fee_per = this.booking_details[0].JP_CHARGE_VALUE;
          }
          var FEES = 0;
          console.log(this.booking_details[0].IM_CONV_FEE_DISCOUNT, "ASSR")
          if (this.booking_details[0].IM_CONV_FEE_DISCOUNT > 0) {
            this.convFeesDiscount = parseFloat(this.booking_details[0].IM_CONV_FEE_DISCOUNT);
            this.convenineceFees = (parseFloat(this.booking_details[0].FEES)) + this.convFeesDiscount;
            FEES = Number(this.convenineceFees);
          } else {
            FEES = Number(this.booking_details[0].FEES);
            this.convenineceFees = Number(this.booking_details[0].FEES);
          }
          console.log("CON_F_D", (this.booking_details[0].IM_CONV_FEE_DISCOUNT))
          var convenience_fees =
            (FEES * 100) / (100 + Number(this.booking_details[0].GST));
          this.Convience_without_gst = convenience_fees;
          this.gst_on_convience =
            Number(FEES) -
            Number(this.Convience_without_gst);
          this.AMOUNT_FOR_EXTRA_MILES =
            Number(this.booking_details_info[0].TOTAL_AMOUNT) -
            (Number(this.booking_details_info[0].GST_ON_MILES) +
              Number(FEES));
          this.GST_ON_ADDITIONAL_MILES = parseFloat(
            this.booking_details_info[0].GST_ON_MILES
          );
          if (this.booking_details_info[0].EARN_MILES == undefined) {
            this.Total_amount_paid =
              FEES +
              this.AMOUNT_FOR_EXTRA_MILES +
              this.GST_ON_ADDITIONAL_MILES;
          } else {
            this.Total_amount_paid =
              parseFloat(this.booking_details[0].TOTAL_FLIGHT_FARE) +
              FEES;
          }
          var TICKET_NO;
          if (
            this.Ticket_details[0].TICKET_NO != null &&
            this.Ticket_details[0].TICKET_NO != ""
          ) {
            TICKET_NO = this.Ticket_details[0].TICKET_NO;
          } else {
            TICKET_NO = "NA";
          }
          var AIRLINE_PNR;
          if (
            this.segment_details[0].AIRLINE_PNR != null &&
            this.segment_details[0].AIRLINE_PNR != ""
          ) {
            AIRLINE_PNR = this.segment_details[0].AIRLINE_PNR;
          } else {
            AIRLINE_PNR = "NA";
          }
          this.Email_ID = this.pax_detail[0].EMAIL_ID;
          // console.log("this.Email_ID ",this.Email_ID);
          for (var p = 0; p < this.pax_detail.length; p++) {
            this.passanger_details = {
              Paxtype: this.pax_detail[p].PASSENGER_TYPE,
              title: this.pax_detail[p].TITLE,
              firstName: this.pax_detail[p].FIRST_NAME,
              lastName: this.pax_detail[p].LAST_NAME,
              email: this.pax_detail[p].EMAIL_ID,
              mobile: this.pax_detail[p].MOBILE_NO,
              DOB: this.pax_detail[p].DOB,
              TICKET_NO: TICKET_NO,
              AIRLINE_PNR: AIRLINE_PNR
            };
            this.passanger_details_Array.push(this.passanger_details);
          }
          this.totalAmount =
            this.JpFees + this.booking_details[0].TOTAL_FLIGHT_FARE;
          this.TRAVEL_TYPE = this.booking_details[0].TRAVEL_TYPE;
          this.DepartureAirport = this.segment_details[0].ORIGIN;
          this.ArivalAirport = this.segment_details[0].DESTINATION;
          this.pnrNumber = this.segment_details[0].AIRLINE_PNR;
          this.tripType = this.booking_details[0].TRIP_TYPE;
          this.SUPPLIER_NAME = this.booking_details[0].SUPPLIER_NAME;
          this.CABIN_CLASS = this.segment_details[0].BOOKING_CLASS;

          if (this.adultsCount == "1") {
            this.adultsCount = this.adultsCount + " Adult";
          } else if (this.adultsCount == "0") {
            this.adultsCount = "";
          } else {
            this.adultsCount = this.adultsCount + " Adults";
          }
          if (this.childsCount == "1") {
            this.childsCount = ", " + this.childsCount + " Child";
          } else if (this.childsCount == "0") {
            this.childsCount = "";
          } else {
            this.childsCount = ", " + this.childsCount + " Childs";
          }
          if (this.infantsCount == "1") {
            this.infantsCount = ", " + this.infantsCount + " Infant";
          } else if (this.infantsCount == "0") {
            this.infantsCount = "";
          } else {
            this.infantsCount = ", " + this.infantsCount + " Infants";
          }
          this.passenegerCount =
            this.adultsCount + this.childsCount + this.infantsCount;
          if (document.getElementById("home") != undefined) {
            document.getElementById("home").style.display = "block";
          }

          /**  Defaul dropdown value */
          this.defaultOne = 1;
          this.defaultTwo = 1;
          this.selectionTab = 1;
          this.onPaxChange(1);

          this.selectionSeg = 1;
          this.selectionLeg = 1;
          this.onPaxChangeDyn(this.selectionPax);
          this.activateFirstTab();
          this.updateAncillariesData();
          this.getAllConfirm();
          this.updateAncillaries(); 
        }
      } else {
        window.history.back();
      }

      for (var k = 0; k < this.pax_seg_details.length; k++) {
        this.paxDiscount = this.paxDiscount + this.pax_seg_details[k].PAX_DISCOUNT
      }
      console.log("paxDiscount", this.paxDiscount);

    });

    this.uploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
    this.uploader.onCompleteItem = (
      item: any,
      response: any,
      status: any,
      headers: any
    ) => { };
  }

  dataMethod(value) {
    var Onward_PNR = this.TBO_Onward_PNR
    var ONWARD_Booking_ID = this.Onward_Booking_ID
    if (value == 0) {
      if (Onward_PNR == undefined || Onward_PNR == null || Onward_PNR.length < 6) {
        document.getElementById("onErr").innerHTML = "";
        this.flag = true
      }
      else {
        document.getElementById("onErr").innerHTML = "";
        this.flag = false
      }
    }

    if (value == 1) {
      if (ONWARD_Booking_ID == undefined || ONWARD_Booking_ID == null) {

        document.getElementById("obnErr").innerHTML = "";
        this.flag = true

      }
      else {
        document.getElementById("obnErr").innerHTML = "";
        this.flag = false
      }
      // if(  Onward_PNR.length >= 5) {
      //   document.getElementById("onErr").innerHTML = ""

      //   }
    }
    if (value == 2) {
      document.getElementById("rnErr").innerHTML = "";
      /* if (Return_PNR == undefined || Return_PNR == null || Return_PNR.length < 6) {
        document.getElementById("rnErr").innerHTML = "";
      }
      else {
        document.getElementById("rnErr").innerHTML = "";
      } */
    }
    if (value == 3) {
      document.getElementById("rbnErr").innerHTML = "";
    }


  }

  TBO_Booking() {
    this.buttonFlag = true;
    this.loader = true;
    var test;
    var TBOdetails = {
      "ORDER_ID": this.booking_ref,
      "firstName": this.passanger_details.firstName,
      "lastName": this.passanger_details.lastName,
      "fare_Category": this.member_category
    }
    if (this.TBO_Type == "RETURN") {

      if (this.TBO_Onward_PNR == this.TBO_Return_PNR && this.Onward_Booking_ID == this.Return_Booking_ID) {
        test = [
          {
            "PNR": this.TBO_Onward_PNR,
            "BookingId": this.Onward_Booking_ID,
            "SEG_NO": 1,
            "Created_by": this.uid,
            "Fare_type": this.Onward_fare_type,
            "Benfits": this.onward_benefits,
            "Remarks": this.Onward_Remarks
          }
        ]

        TBOdetails['pnr'] = test;

      } else {
        var test1 = [
          {
            "PNR": this.TBO_Onward_PNR,
            "BookingId": this.Onward_Booking_ID,
            "SEG_NO": 1,
            "Created_by": this.uid,
            "Fare_type": this.Onward_fare_type,
            "Benfits": this.onward_benefits,
            "Remarks": this.Onward_Remarks
          },
          {
            "PNR": this.TBO_Return_PNR,
            "BookingId": this.Return_Booking_ID,
            "SEG_NO": 2,
            "Created_by": this.uid,
            "Fare_type": this.Return_fare_type,
            "Benfits": this.return_benefits,
            "Remarks": this.Return_Remarks
          }
        ]
        TBOdetails['pnr'] = test1;
      }
    } else {
      test = [
        {
          "PNR": this.TBO_Onward_PNR,
          "BookingId": this.Onward_Booking_ID,
          "SEG_NO": 1,
          "Created_by": this.uid,
          "Fare_type": this.Onward_fare_type,
          "Benfits": this.onward_benefits,
          "Remarks": this.Onward_Remarks
        }
      ]
      TBOdetails['pnr'] = test;
    }
    console.log("PPPPPPPPPPPPP", TBOdetails);

    this.vernostService.get_TBO_Details(TBOdetails).subscribe(Response => {
      if (Response['result']['status']) {
        this.onLoad();
      } else {
        this.loader = false;
        this.TBO_sms = Response['result']['msg']
      }

    });
    this.buttonFlag = false;
  }

  Type(e, val) {

    if ((val == "onwardpnr" || val == "onwardid") && this.TBO_Type == "ONEWAY") {
      if (this.TBO_Onward_PNR != undefined && this.Onward_Booking_ID != undefined && this.TBO_Onward_PNR != "" && this.Onward_Booking_ID != "") {
        //console.log("yiuiyiuygjhjgjgiu")
        this.buttonFlag = false;
      } else {
        this.buttonFlag = true;
      }
    }
    if ((val == "returnpnr" || val == "returnid" || val == "onwardpnr" || val == "onwardid") && this.TBO_Type == "RETURN") {
      if (this.TBO_Return_PNR != undefined && this.Return_Booking_ID != undefined && this.TBO_Return_PNR != "" && this.Return_Booking_ID != "" && this.TBO_Onward_PNR != undefined && this.Onward_Booking_ID != undefined && this.TBO_Onward_PNR != "" && this.Onward_Booking_ID != "") {

        // console.log("yiuiyiuygjhjgjgiu")
        this.buttonFlag = false;
      } else {
        this.buttonFlag = true;
      }


    }
  }


  disEvent(val) {
    this.demo = val.target.value;

    if (this.demo == "ONEWAY") {
      if (this.TBO_Onward_PNR != undefined && this.Onward_Booking_ID != undefined && this.TBO_Onward_PNR != "" && this.Onward_Booking_ID != "") {
        this.buttonFlag = false;
      } else {
        this.buttonFlag = true;
      }

    }
    if (this.demo == "RETURN") {
      if (this.TBO_Return_PNR != undefined && this.Return_Booking_ID != undefined && this.TBO_Return_PNR != "" && this.Return_Booking_ID != "" && this.TBO_Onward_PNR != undefined && this.Onward_Booking_ID != undefined && this.TBO_Onward_PNR != "" && this.Onward_Booking_ID != "") {
        this.buttonFlag = false;
      } else {
        this.buttonFlag = true;

      }

    }

  }


  getSegmentDetails() {
    let data = {
      ORDER_ID: this.booking_ref
    };
    this.vernostService
      .postData("getSegmentDetails", data)
      .subscribe(response => {
        this.Segment_Details = response[0].result;

        for (var i = 0; i < this.Segment_Details.length; i++) {
          this.ADULT_BASE_FARE =
            this.ADULT_BASE_FARE + this.Segment_Details[i].ADULT_BASE_FARE;
          this.CHILD_BASE_FARE =
            this.CHILD_BASE_FARE + this.Segment_Details[i].CHILD_BASE_FARE;
          this.INFANT_BASE_FARE =
            this.INFANT_BASE_FARE + this.Segment_Details[i].INFANT_BASE_FARE;
          this.ADULT_FEE_N_TAXES =
            this.ADULT_FEE_N_TAXES + this.Segment_Details[i].ADULT_FEE_N_TAXES;
          this.CHILD_FEE_N_TAXES =
            this.CHILD_FEE_N_TAXES + this.Segment_Details[i].CHILD_FEE_N_TAXES;
          this.INFANT_FEE_N_TAXES =
            this.INFANT_FEE_N_TAXES +
            this.Segment_Details[i].INFANT_FEE_N_TAXES;
          this.TOTAL_BASE_FARE =
            this.TOTAL_BASE_FARE + this.Segment_Details[i].TOTAL_BASE_FARE;
          this.TOTAL_FEE_N_TAXES =
            this.TOTAL_FEE_N_TAXES + this.Segment_Details[i].TOTAL_FEE_N_TAXES;
          this.TOTAL_AMOUNT =
            this.TOTAL_AMOUNT + this.Segment_Details[i].TOTAL_AMOUNT;
        }
      });
  }

  openCity(evt, cityName) {
    this.commonService.openCity(evt, cityName);
    if (cityName == 'menu6') {
      this.historyReload()
    }
  }


  closeBooking() {
    this.router.navigate(['/navigation', 'orderbooking']);
  }

  openNav(id) {
    let openNavResponse = this.commonService.openNav(id);
    this.arrayId = openNavResponse[0].arrayId;
    this.passanger_details = openNavResponse[0].passanger_details;
    this.Charge_Details = openNavResponse[0].Charge_Details;
    this.Note_details = openNavResponse[0].Note_details;
  }

  closeNav(id) {
   this.commonService.closeNav(id);
  }

  AddPaxData(id) {
    if (this.arrayId == "NA") {
      var data = {
        details: this.passanger_details,
        BRno: this.FB_BOOKING_REF_NO
      };
      this.vernostService.AddPaxOms(data).subscribe(response => {
      });

      this.passanger_details_Array.push(this.passanger_details);
    }

    this.commonService.closeNav(id);
  }

  // updatepax(id, i) {
  //   this.arrayId = i;
  //   this.passanger_details = this.passanger_details_Array[i];
  //   this.Paxtype = this.passanger_details_Array[i].Paxtype;
  //   document.getElementById(id).style.width = "90%";
  //   document.getElementById(id + "head").style.width = "100%";
  // }

  SelectPaxType() {
    this.Paxtype = (document.getElementById(
      "selectPax"
    ) as HTMLSelectElement).value;
  }
  AddChargeData(id) {
    console.log("AddChargeData called")
    if (this.arrayId == "NA") {
      this.Charge_Details.createdDate = new Date();
      this.Charge_Details_Brakup.push(this.Charge_Details);
    }

    if (this.Charge_Details.chargeType == "CHG") {
      this.totalAmount =
        parseFloat(this.totalAmount) + parseFloat(this.Charge_Details.amount);
    } else {
      this.totalAmount =
        parseFloat(this.totalAmount) - parseFloat(this.Charge_Details.amount);
    }

    this.commonService.closeNav(id);
  }


  // UpdateCharge(id, i) {
  //   this.arrayId = i;
  //   this.Charge_Details = this.Charge_Details_Brakup[i];
  //   document.getElementById(id).style.width = "90%";
  //   document.getElementById(id + "head").style.width = "100%";
  // }

  // printFile() {
  //   this.booking_details_info[0].BOOKING_STATUS = 2;
  //   var headerLogOrder =
  //     this.booking_details_info[0].JP_NUMBER +
  //     "_" +
  //     this.booking_details_info[0].ORDER_ID +
  //     "_" +
  //     this.booking_details_info[0].BOOKING_STATUS +
  //     ".pdf";

  //   var urlOrder = "fetchpdf?name=" + headerLogOrder + "/check";
  //   this.vernostService.getDataApi(urlOrder).subscribe(response => {
  //     // alert("response");

  //     if (response["status"] == "Success") {
  //       var w = window.open(URL + headerLogOrder);
  //       w.print();
  //     } else {
  //       this.ErrMsg = response["msg"];
  //       setTimeout(() => {
  //         this.ErrMsg = "";
  //       }, 4000);
  //     }
  //   });
  // }
  // print(doc) {
  //   var objFra = document.createElement("iframe"); // Create an IFrame.
  //   objFra.style.visibility = "hidden"; // Hide the frame.
  //   objFra.src = doc; // Set source.
  //   document.body.appendChild(objFra); // Add the frame to the web page.
  //   objFra.contentWindow.focus(); // Set focus.
  //   objFra.contentWindow.print(); // Print it.
  // }

  isNoteEmpty() {
    if (
      this.Note_details.noteText != undefined &&
      this.Note_details.noteText != null &&
      this.Note_details.noteText != ""
    ) {
      document.getElementById("NoteErr").innerHTML = "";
    }
  }
  // AddNote(id) {
  //   if (
  //     this.Note_details.noteText != undefined &&
  //     this.Note_details.noteText != null &&
  //     this.Note_details.noteText != ""
  //   ) {
  //     document.getElementById("NoteErr").innerHTML = "";
  //     this.Note_details.createdDate = new Date();
  //     this.Note_details_Array.push(this.Note_details);

  //     document.getElementById(id).style.width = "0%";
  //     document.getElementById(id + "head").style.width = "0%";

  //     var data = {
  //       details: this.Note_details,
  //       document: this.uploaded_file_name,
  //       fname: this.fname,
  //       FB_BOOKING_REF_NO: this.FB_BOOKING_REF_NO
  //     };

  //     this.vernostService.AddNoteOms(data).subscribe(response => {
  //       // alert("response");
  //     });
  //   } else {
  //     document.getElementById("NoteErr").innerHTML = "Note Text Cant be Blank";
  //     document.getElementById("NoteErr").style.color = "red";
  //   }
  //   //******************************* /
  // }
  
  addSegment() {
    this.Leg_detailsArray.push("1");
  }
  removeSegment() {
    this.Leg_detailsArray.pop();
  }
  keypresshandler(event) {
    var charCode = event.keyCode;
    //Non-numeric character range
    //console.log("eventhhksnknlk=====>", event);

    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
  }


  l
  getFileDetails(event) {
    for (var i = 0; i < event.target.files.length; i++) {
      var name = event.target.files[i].name;
      this.uploaded_file_name = name;
      this.uploader.uploadAll();
    }
  }

  openUpdate() {
    var data = {
      FB_BOOKING_REF_NO: this.FB_BOOKING_REF_NO
    };

    var url = "getPaxSegData";
    this.vernostService.postData(url, data).subscribe(res => {

      if (res[0].status == "Sucess") {

        this.paxSegDataDetails = res[0].result;
        this.paxSegDataDetails.forEach(element => {
          console.log("element : ", element)
          if (element.PROMO_CODE_TYPE == "SWM") {
            console.log("Its SWM")
            this.swmUsed = {
              promocode_type: element.PROMO_CODE_TYPE,
              promocode_amount: element.PROMO_CODE_MILES,
              promocode_discount_amount: element.PROMO_CODE_AMOUNT
            }
            console.log("this.swmUsed-->", this.swmUsed)
          }
          if (element.PROMO_CODE == "imflat500") {
            console.log("Its imflat500")
            this.flat500Offer = {
              promocode_type: element.PROMO_CODE_TYPE,
              promocode_amount: element.PROMO_CODE_AMOUNT
            }
            console.log("this.flat500Offer", this.flat500Offer)
          }
          if (element.PROMO_CODE_TYPE == "instant_offer") {
            this.frenzyOffer = {
              promocode_type: element.PROMO_CODE_TYPE,
              promocode_amount: element.PROMO_CODE_AMOUNT
            }
            console.log("this.frenzyOffer-->", this.frenzyOffer)
          }
          if (element.PROMO_CODE_TYPE == "SWM_BONUS") {
            this.swmBonus = {
              promocode_type: element.PROMO_CODE_TYPE,
              promocode_amount: element.PROMO_CODE_AMOUNT
            }
            console.log("this.swmBonus-->", this.swmBonus)
          }

          if (element.PROMO_CODE_TYPE && element.PROMO_CODE_TYPE.includes('CPERKS-') && element.PROMO_CODE_TYPE != 'CPERKS-FC') {
            this.genericOfferDiscountTitle = element.DISCOUNT_TITLE;
            this.genericOfferDiscountAmount = element.PROMO_CODE_AMOUNT

          }

          if (this.AirlinePnrArray.indexOf(element.SEGMENT_REF_NO) == -1) {
            this.AirlinePnrArray.push(element.SEGMENT_REF_NO);
          }
        });
      }
    });
  }
  emailerr: any = "";
  updatePnr() {
    var airlinePnrArr = [];
    var ticketNo = [];
    // console.log("this.Email_ID", this.Email_ID);
    var isValidEmail = "";
    var isValidPnr = "";
    var isValidTicket = "";
    var isSupplierValid = "";
    var SupplierArray = [];
    if (!this.IsOnlySid) {
      if (
        this.Email_ID != undefined &&
        this.Email_ID != null &&
        this.Email_ID != ""
      ) {
        isValidEmail = "true";
        this.emailerr = "";
      } else {
        this.emailerr = "Please Enter Email";
        isValidEmail = "false";
      }
      for (var i = 0; i < this.paxSegDataDetails.length; i++) {
        var TICKET_NUMBER = (document.getElementById(
          "ticketNo" + i
        ) as HTMLInputElement).value;
        if (
          TICKET_NUMBER == undefined ||
          TICKET_NUMBER == null ||
          TICKET_NUMBER == ""
        ) {
          isValidTicket = "false";
          document.getElementById("ticketNoErr" + i).innerHTML =
            "Please Enter Ticket No";
        } else {
          document.getElementById("ticketNoErr" + i).innerHTML = "";
          isValidTicket = "true";
          this.paxSegDataDetails[i].TICKET_NO = TICKET_NUMBER;
          ticketNo.push(TICKET_NUMBER);
        }
      }
      for (var k = 0; k < this.AirlinePnrArray.length; k++) {
        var AIRLINE_PNR = (document.getElementById(
          "airlinePnr" + k
        ) as HTMLInputElement).value;
        if (
          AIRLINE_PNR == undefined ||
          AIRLINE_PNR == null ||
          AIRLINE_PNR == ""
        ) {
          isValidPnr = "false";
          document.getElementById("airlinePnrErr" + k).innerHTML =
            "Please select Airline PNR";
        } else {
          document.getElementById("airlinePnrErr" + k).innerHTML = "";
          isValidPnr = "true";
          AIRLINE_PNR = AIRLINE_PNR.toUpperCase();
          airlinePnrArr.push(AIRLINE_PNR);
        }
      }
      if (this.SID == '' && this.isEmtRequired) {
        console.log("DD", this.supplierIdList)
        for (var x = 0; x < this.supplierIdList.length; x++) {
          if (this.supplierIdList[x].SUPPLIER_ID != undefined && this.supplierIdList[x].SUPPLIER_ID != null
            && this.supplierIdList[x].SUPPLIER_ID != '') {
            this.siderr = "";
            isSupplierValid = "true";
            if (document.getElementById("siderr" + x) != null) {
              document.getElementById("siderr" + x).innerHTML = "";
            }
          } else {
            this.siderr = "Please Enter Supplier ID";
            if (document.getElementById("siderr" + x) != null) {
              document.getElementById("siderr" + x).innerHTML = "Please Enter Supplier ID";
            }
            isSupplierValid = "false"
          }
        }
      } else {
        isSupplierValid = "true"
      }
    }
    if (this.IsOnlySid) {
      for (var t = 0; t < this.supplierIdList.length; t++) {
        if (this.supplierIdList[t].SUPPLIER_ID != undefined && this.supplierIdList[t].SUPPLIER_ID != null
          && this.supplierIdList[t].SUPPLIER_ID != '') {
          this.siderr = "";
          isSupplierValid = "true";
          if (document.getElementById("siderr" + t) != null) {
            document.getElementById("siderr" + t).innerHTML = "";
          }
        } else {
          this.siderr = "Please Enter Supplier ID";
          if (document.getElementById("siderr" + t) != null) {
            document.getElementById("siderr" + t).innerHTML = "Please Enter Supplier ID";
          }
          isSupplierValid = "false"
        }
      }
    }
    
    if (
      (isValidEmail == "true" &&
        isValidPnr == "true" &&
        isValidTicket == "true" && isSupplierValid == "true") || (this.IsOnlySid && isSupplierValid == "true")
    ) {
      SupplierArray = [];
      for (var p = 0; p < this.supplierIdList.length; p++) {
        SupplierArray.push({ "SEGMENT_NO": this.supplierIdList[p].SEGMENT_NO, "SUPPLIER_ID": this.supplierIdList[p].SUPPLIER_ID });
      }
      this.isPnrUpdated = true;
      var data = {
        airlinePnrArr: airlinePnrArr,
        ticketNo: ticketNo,
        paxSegDataDetails: this.paxSegDataDetails,
        FB_BOOKING_REF_NO: this.FB_BOOKING_REF_NO,
        SUPPLIER_ID: SupplierArray,
        ORDER_ID: this.booking_details[0].ORDER_ID,
        USER_ID: this.uid,
        USER_NAME: this.fname + " " + this.lname,
        user_id: this.uid
      };
      this.coms_booking_status['status'] = "Confirmed";
      data['coms_booking_status'] = this.coms_booking_status;
      //For Travone API to be available
      this.callUpdatePNRService();
      var url = "updatePnr";
      this.vernostService.postData(url, data).subscribe(res => {
        if (res[0].status == "Sucess") {
          if (this.SUPPLIER_ID != undefined && this.SUPPLIER_ID != null && this.SUPPLIER_ID != '') {
            this.booking_details[0].SUPPLIER_ID = this.booking_details[0].ORDER_ID + "#" + this.SUPPLIER_ID.toUpperCase();
          }
          if (airlinePnrArr != undefined && airlinePnrArr != null && airlinePnrArr.length != 0) {
            this.booking_details[0].BOOKING_STATUS = 2;
            this.crisPnrUpdate();
            this.generatePdf(airlinePnrArr, ticketNo, this.Email_ID);
          } else {
            this.IsOnlySid = !this.IsOnlySid;
          }
        }
        this.isPnrUpdated = false;
        document.getElementById("closePnr").click();
      });
    }
  }
  
  callUpdatePNRService() {
    try {
      let IS_OFFLINE_BOOKING_PROCESSED = 0; // 0 or null ==> Success, 1 is Failed
      let onward_supplier_id = !!this.segment_details[0].SUPPLIER_ID ? this.segment_details[0].SUPPLIER_ID : "";
      onward_supplier_id = !!onward_supplier_id ? onward_supplier_id : this.supplierIdList[0].SUPPLIER_ID;
      let return_supplier_id = "";
      let ORDER_ID = (this.booking_details[0].ORDER_ID.length == 18 ? '' : 'JPUB') + this.booking_details[0].ORDER_ID;
      if (this.segment_details.length > 1) {
        return_supplier_id = !!this.segment_details[1].SUPPLIER_ID ? this.segment_details[1].SUPPLIER_ID : "";
        return_supplier_id = !!return_supplier_id ? return_supplier_id : this.supplierIdList[1].SUPPLIER_ID;
      }

      let travoneUpdatePnrRequest = {
        "orderId": ORDER_ID,
        "isdomestic": this.booking_details[0].TRAVEL_TYPE == "DOMESTIC" ? true : false,
        "onwarddetail": {
          "suppliertransid": onward_supplier_id
        },
        "returndetail": {
          "suppliertransid": return_supplier_id
        },
        "isearn":true
      }

      let updatePNRURL = "travone_updatepnr";

      this.vernostService.postData(updatePNRURL, travoneUpdatePnrRequest).subscribe(updatePNRResponse => {
        console.log("======== Travone Update PNR Response ==========", updatePNRResponse);
        let REVISED_PAX_FARE_DETAILS = [];
        if (updatePNRResponse['result']) {
          let paxdetails = updatePNRResponse['result'].result.paxdetails
          for (let pax of paxdetails) {
            if (pax.pxstatus == "confirm") {
              let SEGMENT_NO = 1;
              SEGMENT_NO = pax.triptype == "InBound" ? 2 : 1;
              let REVISED_PAX_DETAILS = {
                "REVISED_BASE_FARE": pax.bfr,
                "REVISED_TOTAL_TAX": pax.ttx,
                "REVISED_FLIGHT_FARE": pax.bfr + pax.ttx,
                "SEGMENT_NO": SEGMENT_NO,
                "PASSENGER_NO": pax.pxfid,
                "PASSENGER_TYPE": pax.pxtype,
                "REVISED_TAX_BREAKUP": pax.taxbreakup
              }
              REVISED_PAX_FARE_DETAILS.push(REVISED_PAX_DETAILS);
            }
          }
          if (REVISED_PAX_FARE_DETAILS.length > 0) {
            let updateRevisedData = {
              "fbBookingRefNo": this.FB_BOOKING_REF_NO,
              "revisedFareDetails": REVISED_PAX_FARE_DETAILS
            }
            let updateRevisedDataURL = "updateRevisedFares";
            this.vernostService.postData(updateRevisedDataURL, updateRevisedData).subscribe(res => {
              console.log("========== REVISED DATA UPDATED SUCCESSFULLY ===========", res);
            })
          } else {
            IS_OFFLINE_BOOKING_PROCESSED = 1;
          }
        } else {
          IS_OFFLINE_BOOKING_PROCESSED = 1;
        }

        if (!!IS_OFFLINE_BOOKING_PROCESSED) {
          let req = {
            "ORDER_ID": ORDER_ID,
            "IS_OFFLINE_BOOKING_PROCESSED": IS_OFFLINE_BOOKING_PROCESSED
          }
          let url = "updateOfflineBookingStatus";
          this.vernostService.postData(url, req);
        }
      });
    } catch (e) {
      console.log("========= Some Error Occured in Call Update PNR Service: ==>", e);
    }
  }

  closePnr() {
    this.emailerr = "";
    this.SUPPLIER_ID = "";
    this.siderr = "";
    // this.Email_ID = "";
    if (!this.IsOnlySid) {
      for (var i = 0; i < this.paxSegDataDetails.length; i++) {
        if (document.getElementById("ticketNoErr" + i) != null) {
          document.getElementById("ticketNoErr" + i).innerHTML = "";
          (document.getElementById("ticketNo" + i) as HTMLInputElement).value = "";
        }
      }
      for (var k = 0; k < this.AirlinePnrArray.length; k++) {
        if (document.getElementById("airlinePnrErr" + k) != null) {
          document.getElementById("airlinePnrErr" + k).innerHTML = "";
          (document.getElementById("airlinePnr" + k) as HTMLInputElement).value = "";
        }
      }
    }
  }
  generatePdf(airlinePnrArr, ticketNo, Email_ID) {
    var i = 0;
    this.passanger_details_Array.forEach(element => {
      element.TICKET_NO = ticketNo[i];
      element.AIRLINE_PNR = airlinePnrArr;
      i++;
    });
    setTimeout(() => {
      this.sendNewInvoiceMail();
      this.PnrMsg = "Ticket No and PNR Updated";
      this.IS_EMAIL_SENT = 1;
      this.isPnrUpdated = false;
    }, 10000);
    this.BOOKING_STATUS = "2";
    this.updatedPNR = false;
  }

  EarnMiles() {
    var req = {
      ORDER_ID: this.booking_details_info[0].ORDER_ID
    };
    var url = "earnJmiles";
    this.vernostService.postData(url, req).subscribe(res => {
      console.log("res::::", res);
    });
  }
  cancellation_per_User_tier = "";
  getRPM() {
    var url = "getRPM";
    this.vernostService.getDataApi(url).subscribe(
      response => {
        var Response = response[0];
        //   console.log("Response", Response);
        Response.result.forEach(element => {
          this.cancellation_per_User_tier = element.CANCELLATION_PENALTY;
        });
      },
      err => { }
    );
    return this.cancellation_per_User_tier;
  }

  cal_total_price_amount: any;
  cal_additional_convenience_fees: any;
  cal_additional_convenience_fees_gst: any;
  cal_convenience_fees: any;
  cal_gst_on_convenience_fees: any;
  convenience_breakup: any;
  calculateFareProduct(bookingInfo) {
    this.cal_total_price_amount = bookingInfo.TOTAL_AMOUNT.toFixed(2);
    var bookingNoOfSeg;
    var bookingPassengers;
    var more_to_buy = 0;    
    var FEES;
    var convenience_fees;
    var gst_on_convenience_fees;
    if (typeof bookingInfo.NO_OF_SEGMENT == "string") {
      bookingNoOfSeg = Number(bookingInfo.NO_OF_SEGMENT);
    } else {
      bookingNoOfSeg = bookingInfo.NO_OF_SEGMENT;
    }
    bookingPassengers = Number(bookingInfo.NO_OF_PASSENGER);
    more_to_buy = Number(bookingInfo.MORE_TO_BUY_JPMILES);
    if (more_to_buy > 0) {
      FEES = Number(bookingInfo.FEES);
      var additional_convenience_fees = Number(
        bookingInfo.COST_OF_ADDITIONAL_MILES
      );
      var additional_convenience_fees_gst = Number(bookingInfo.GST_ON_MILES);
      convenience_fees = (FEES * 100) / (100 + Number(bookingInfo.GST));
      gst_on_convenience_fees = convenience_fees * (Number(bookingInfo.GST) / 100);
      this.cal_additional_convenience_fees = additional_convenience_fees.toFixed(2);
      this.cal_additional_convenience_fees_gst = additional_convenience_fees_gst.toFixed(2);
      this.cal_convenience_fees = convenience_fees.toFixed(2);
      this.cal_gst_on_convenience_fees = gst_on_convenience_fees.toFixed(2);
      this.convenience_breakup = bookingNoOfSeg + " * " + bookingPassengers + " * " + this.JpFees;
    } else {
      FEES = Number(bookingInfo.FEES);
      convenience_fees = (FEES * 100) / (100 + Number(bookingInfo.GST));
      gst_on_convenience_fees = convenience_fees * (Number(bookingInfo.GST) / 100);
      this.cal_convenience_fees = convenience_fees.toFixed(2);
      this.cal_gst_on_convenience_fees = gst_on_convenience_fees.toFixed(2);
      this.cal_additional_convenience_fees = "";
      this.cal_additional_convenience_fees_gst = "";
    }
  }

  sendEmail(airlinePnr, ticketNo, Email_ID) {
    var SegmentAirlinePnrs = [];
    var OnewayPnr = [];
    var RoundPnr = [];
    var j = 0;
    var Oneway_Ticket = [];
    var Ticket_Numbers = [];
    var Return_Ticket = [];
    this.paxSegDataDetails.forEach(element => {
      if (element.SEGMENT_REF_NO == 1) {
        Oneway_Ticket.push(ticketNo[j]);
        OnewayPnr.push(airlinePnr[0]);
      } else {
        Return_Ticket.push(ticketNo[j]);
        if (airlinePnr[0] == airlinePnr[1]) {
          RoundPnr.push(airlinePnr[0]);
        } else {
          RoundPnr.push(airlinePnr[0] + " , " + airlinePnr[1]);
        }
      }
      j++;
    });
    // console.log("Oneway_Ticket", Oneway_Ticket);
    //console.log("Return_Ticket", Return_Ticket);
    var k = 0;
    Oneway_Ticket.forEach(element => {
      if (Return_Ticket.length == 0) {
        if (element != undefined && element != null && element != "") {
          Ticket_Numbers.push(element);
          SegmentAirlinePnrs.push(OnewayPnr[k]);
        } else {
          Ticket_Numbers.push("NA");
          SegmentAirlinePnrs.push("NA");
        }
      } else {
        if (element != undefined && element != null && element != "") {
          if (
            Return_Ticket[k] != undefined &&
            Return_Ticket[k] != null &&
            Return_Ticket[k] != ""
          ) {
            if (element == Return_Ticket[k]) {
              Ticket_Numbers.push(element);
            } else {
              Ticket_Numbers.push(element + " , " + Return_Ticket[k]);
            }
            SegmentAirlinePnrs.push(RoundPnr[k]);
          } else {
            SegmentAirlinePnrs.push(OnewayPnr[k]);
            Ticket_Numbers.push(element);
          }
        }
      }
      k++;
    });
    for (var i = 0; i < this.pax_detail.length; i++) {
      this.pax_detail[i].TICKET_NO = Ticket_Numbers[i];
      this.pax_detail[i].AIRLINE_PNR = SegmentAirlinePnrs[i];
    }
    // this.segment_details[0].AIRLINE_PNR = airlinePnr;
    // console.log("this.pax_detail", this.pax_detail);
    var headerLog =
      this.booking_details_info[0].JP_NUMBER +
      "_" +
      this.booking_details_info[0].ORDER_ID +
      "_2";
    // this.Leg_details[0].FLIGHT_DURATION = "01h 45m";
    // this.pax_detail[0].TITLE ="MRS";
    var sendmailreq = {
      to: Email_ID,
      html: "",
      fileName: headerLog,
      paxData: this.pax_detail,
      bookingData: this.booking_details_info[0],
      segmentDetails: this.segment_details,
      subj:
        "You’re ready for take off! Booking Reference Number is " +
        "JPUB" +
        this.booking_details_info[0].ORDER_ID,
      cal_total_price_amount: this.cal_total_price_amount,
      cal_additional_convenience_fees: this.cal_additional_convenience_fees,
      cal_additional_convenience_fees_gst: this
        .cal_additional_convenience_fees_gst,
      cal_convenience_fees: this.cal_convenience_fees,
      cal_gst_on_convenience_fees: this.cal_gst_on_convenience_fees,
      legInfo: this.Leg_details
    };
    var url = "sendmail";
    var data = {
      sendmailreq: sendmailreq
    };
    // console.log("data", data);
    this.vernostService.postData(url, data).subscribe(res => {
      // console.log("res",res);
      this.isPnrUpdated = false;
      if (res["msg"] == "SENT") {
        // console.log("msg",res["msg"]);
        // this.updatedPNR = false;
        this.PnrMsg = "Ticket No and PNR Updated";
        this.IS_EMAIL_SENT = 1;
        setTimeout(() => {
          this.PnrMsg = "";
        }, 4000);
        this.BOOKING_STATUS = "2";
        this.updatedPNR = false;
      } else {
        // this.updatedPNR = false;
      }
    });
  }
  sendInvoiceMail() {
    this.isPnrUpdated = true;
    var url = "";
    var sendmailreq = {
      to: this.Email_ID,
      ORDER_ID: this.booking_details_info[0].ORDER_ID
    };
    if (this.booking_details_info[0].EARN_MILES == undefined) {
      url = "sendinvoice";
      this.vernostService.postData(url, sendmailreq).subscribe(res => {
        this.isPnrUpdated = false;
        if (res["msg"] == "SENT") {
          this.ErrMsg = "Email Sended To CM";
          this.IS_EMAIL_SENT = 1;
          setTimeout(() => {
            this.ErrMsg = "";
            this.PnrMsg = "";
          }, 4000);
        }
      });
    } else {
      url = "sendinvoiceacc";
      this.vernostService.postData(url, sendmailreq).subscribe(res => {
        this.isPnrUpdated = false;
        if (res == true) {
          this.ErrMsg = "Email Sended To CM";
          this.IS_EMAIL_SENT = 1;
          setTimeout(() => {
            this.ErrMsg = "";
          }, 4000);
        }
      });
    }
  }
  crisPnrUpdate() {
    if ((this.booking_ref.toString().startsWith('IBFR')) || this.booking_details[0].ORDER_ID < 50000000000) {
      let data = {
        ORDER_ID: this.booking_details[0].ORDER_ID,
        JP_NUMBER: this.booking_details[0].JP_NUMBER,
        FB_BOOKING_REF_NO: this.booking_details[0].FB_BOOKING_REF_NO
      }
      this.vernostService.crisPnrUpdate(data).subscribe(res => {
        console.log("CRIS PNR Update res::", res);
      })
    }
  }
  sendNewInvoiceMail() {
    this.isPnrUpdated = true;
    // var sendmailreq = {
    //   ORDER_ID: this.booking_details_info[0].ORDER_ID
    // };
    // console.log("sendmailreq",sendmailreq);

    var sendmailreq = {
      "type": "",
      "ORDER_ID": this.booking_details_info[0].ORDER_ID,
      "invoiceType": "UB_TAX_INVOICE",
      "bookingtype": ""
    }
    if (this.booking_details_info[0].EARN_MILES == undefined) {
      sendmailreq.type = "UB_R_Booking_Success_New_1";
      sendmailreq.bookingtype = "UBR";
    } else {
      sendmailreq.type = "UB_A_Booking_Success_New_1";
      sendmailreq.bookingtype = "UBA";
    }
    console.log("sendmailreq", sendmailreq);
    var url = 'sendnewemails';
    this.vernostService.postData(url, sendmailreq).subscribe(res => {
      this.isPnrUpdated = false;
      // console.log(res)
      // if (res != undefined && res["email"] == true) {
      this.ErrMsg = "Email Sent To CM";
      this.IS_EMAIL_SENT = 1;
      setTimeout(() => {
        this.ErrMsg = "";
        this.PnrMsg = "";
      }, 4000);
      // }

    });

  }

  Reversal() {
    var ORDER_ID = this.booking_details_info[0].ORDER_ID;

    // console.log("BOOKING_STATUS::", this.BOOKING_STATUS);
    // console.log("CRIS_STATUS::", this.CRIS_STATUS);
    // console.log("TRANSACTION_STATUS::", this.TRANSACTION_STATUS);
    var data = {
      ORDER_ID: ORDER_ID,
      FB_BOOKING_REF_NO: this.FB_BOOKING_REF_NO,
      USER_ID: this.uid,
      USER_NAME: this.fname + " " + this.lname,
      user_id: this.uid
    };
    this.coms_booking_status['status'] = "Failed";
    data['coms_booking_status'] = this.coms_booking_status;
    // console.log("orderid for refund",data);
    this.updateStatus(data);
    //  this.refundAmount(data);
    // this.reverseMiles(data);
    // this.AccrualMiles(data);
  }
  updateStatus(data) {
    var urlPG = "changeStatus";
    this.vernostService.postData(urlPG, data).subscribe(res => {
      // console.log(res[0].msg);
      if (res[0].msg == "success") {
        this.updatedPNR = true;
        this.PnrMsg = "Your Reversal is in Progress...";
        this.booking_details[0].BOOKING_STATUS = 4;
        this.BOOKING_STATUS = "4";

        setTimeout(() => {
          this.PnrMsg = "";
        }, 4000);
      } else {
        this.updatedPNR = false;
      }
    });
  }
  refundAmount(data) {
    var AMOUNT = "";
    var JPMILES = "";
    var urlPG = "reversalPG";
    this.vernostService.postData(urlPG, data).subscribe(res => {
    });

    //ubPayment_trnszaction
  }
  reverseMiles(data) {
    var url = "reversal";
    this.vernostService.postData(url, data).subscribe(res => {
      //console.log("RES", res);
    });
  }
  AccrualMiles(data) {
    //console.log("Reversal Started")
    var url = "accrual";
    this.vernostService.postData(url, data).subscribe(res => {
      //console.log("RES", res);
    });
  }
  updatePNRPriceRecheck() {
    var url = "storepricerecheck";
    var store_pending_prize_check_req = {
      PR_BOOKING_ID: this.booking_details_info[0].ORDER_ID,
      PR_REQ: "",
      PR_RESPONSE: "test",
      TYPE: "FETCH"
    };
    this.vernostService
      .postData(url, store_pending_prize_check_req)
      .subscribe(res => {
        url = "call_update_pnr_prize_check";
        var prize_recheck_call = {
          flt_fare: this.booking_details[0].TOTAL_FLIGHT_FARE,
          req: res[0].PR_REQ
        };
        this.vernostService
          .postData(url, prize_recheck_call)
          .subscribe(prize_check_res => {
            if (prize_check_res["isPriceChange"] == true) {
              this.isPriceChange = true;
            } else {
              this.isPriceChange = false;
              this.updatePnr();
            }
          });
      });
  }

  segmentSelection(selection) {
    this.selectionTab = selection;
  }

  showAncilariesDiv = false;
  onPaxChange(value) {
    console.log("onPaxChange:", value);
    if (value) {
      this.current_ancilaries_details = [];
      if (this.ancilaries_details.length > 0) {
        for (let data of this.ancilaries_details) {
          if (
            data.SEGMENT_REF_NO == this.selectionTab &&
            data.PASSENGER_NO == value
          ) {
            this.showAncilariesDiv = true;
            this.ANCILARIES_STATUS = data;
            this.current_ancilaries_details.push(data)
            console.log(this.selectionTab, "data.PASSENGER_NO:", data.PASSENGER_NO, ",this.ANCILARIES_STATUS:", this.ANCILARIES_STATUS)
          }
        }
      }
      console.log("current_ancilaries_details:", this.current_ancilaries_details)
      this.updateAncillariesBtn();
      this.updateAncillariesData();
    }
  }

  ancilariesView(data) {
    let flag = false;
    if (data.length > 0) {
      data.forEach(element => {
        if (element.BOOKING_STATUS !== 0) {
          flag = true;
        } else {
          flag = false;
        }
      });
    }
    return flag;
  }

  updateAncillaries() {
    try {
      if (this.ancilaries_details.length > 0) {
        this.ancilaries_details.forEach(x => {
          if(x.SSR_TYPE == 1 && x.SEGMENT_REF_NO == 1 && x.SSR_CODE != null) {
            this.MEAL_MILES = this.MEAL_MILES + parseInt(x.MILES);
          };
          if(x.SSR_TYPE == 2 && x.SEGMENT_REF_NO == 1 && x.SSR_CODE != null) {
            this.BAGGAGE_MILES = this.BAGGAGE_MILES + parseInt(x.MILES);
          }; 
          if(x.SSR_TYPE == 3 && x.SEGMENT_REF_NO == 1 && x.SSR_CODE != null) {
            this.SEAT_MILES = this.SEAT_MILES + parseInt(x.MILES);
          };
          if(x.SSR_TYPE == 4 && x.SEGMENT_REF_NO == 1 && x.SSR_CODE != null) {
            this.LOUNGE_MILES = this.LOUNGE_MILES + parseInt(x.MILES);
          };
          if(x.SSR_TYPE == 1 && x.SEGMENT_REF_NO == 2 && x.SSR_CODE != null) {
            this.MEAL_MILES = this.MEAL_MILES + parseInt(x.MILES);
          };
          if(x.SSR_TYPE == 2 && x.SEGMENT_REF_NO == 2 && x.SSR_CODE != null) {
            this.BAGGAGE_MILES = this.BAGGAGE_MILES + parseInt(x.MILES);
          }; 
          if(x.SSR_TYPE == 3 && x.SEGMENT_REF_NO == 2 && x.SSR_CODE != null) {
            this.SEAT_MILES = this.SEAT_MILES + parseInt(x.MILES);
          };
          if(x.SSR_TYPE == 4 && x.SEGMENT_REF_NO == 2 && x.SSR_CODE != null) {
            this.LOUNGE_MILES = this.LOUNGE_MILES + parseInt(x.MILES);
          };
          if (x.SSR_TYPE == 0) {
            this.TI_MILES = this.TI_MILES + parseInt(x.MILES);
          };
        });
      };
    } catch (error) {
      console.log("error", error);
    };
  };

  updateAncillariesBtn() {
    if (this.ancilaries_details.length > 0) {
      this.ancilaries_details.forEach(x => {
        console.log("this.ancilaries_details###########", x);
        if (x.SSR_TYPE == 1 && x.SEGMENT_REF_NO == 1) {
          if (x.SSR_CODE != null && x.SSR_MEMBER_BENEFIT_DETAILID != null && x.SSR_EXTERNAL_DETAILID != null) {
            this.mealInbound.amount = x.SSR_AMOUNT = 0;
            this.mealInbound.miles = x.MILES = 0;
          } else {
            this.mealInbound.description = x.DESCRIPTION;
            this.mealInbound.amount = x.SSR_AMOUNT;
            this.mealInbound.miles = x.MILES;
            this.mealInbound.bkgStatus = x.BOOKING_STATUS;
          }
        } else if (x.SSR_TYPE == 2 && x.SEGMENT_REF_NO == 1) {
          if (x.SSR_CODE != null && x.SSR_MEMBER_BENEFIT_DETAILID != null && x.SSR_EXTERNAL_DETAILID != null) {
            this.baggageInbound.amount = x.SSR_AMOUNT;
            this.baggageInbound.miles = x.MILES = 0;
          } else {
            this.baggageInbound.description = x.DESCRIPTION;
            this.baggageInbound.amount = x.SSR_AMOUNT;
            this.baggageInbound.miles = x.MILES;
            this.baggageInbound.bkgStatus = x.BOOKING_STATUS;
          }
        } else if (x.SSR_TYPE == 3 && x.SEGMENT_REF_NO == 1) {
          if (x.SSR_CODE != null && x.SSR_MEMBER_BENEFIT_DETAILID != null && x.SSR_EXTERNAL_DETAILID != null) {
            this.seatInbound.amount = x.SSR_AMOUNT = 0;
            this.seatInbound.miles = x.MILES = 0;
            this.SEAT_MILES = this.SEAT_MILES + parseInt(x.MILES);
          } else {
            this.seatInbound.description = x.DESCRIPTION;
            this.seatInbound.amount = x.SSR_AMOUNT;
            this.seatInbound.miles = x.MILES;
            this.seatInbound.bkgStatus = x.BOOKING_STATUS;
          }
        } else if (x.SSR_TYPE == 4 && x.SEGMENT_REF_NO == 1) {
          if (x.SSR_CODE != null && x.SSR_MEMBER_BENEFIT_DETAILID != null && x.SSR_EXTERNAL_DETAILID != null) {
            this.loungeInbound.amount = x.SSR_AMOUNT = 0;
            this.loungeInbound.miles = x.MILES = 0;
          } else {
            this.loungeInbound.description = x.DESCRIPTION;
            this.loungeInbound.amount = x.SSR_AMOUNT;
            this.loungeInbound.miles = x.MILES;
            this.loungeInbound.bkgStatus = x.BOOKING_STATUS;
          }
        } else if (x.SSR_TYPE == 1 && x.SEGMENT_REF_NO == 2) {
          if (x.SSR_CODE != null && x.SSR_MEMBER_BENEFIT_DETAILID != null && x.SSR_EXTERNAL_DETAILID != null) {
            this.mealOutbound.amount = x.SSR_AMOUNT = 0;
            this.mealOutbound.miles = x.MILES = 0;
          } else {
            this.mealOutbound.description = x.DESCRIPTION;
            this.mealOutbound.amount = x.SSR_AMOUNT;
            this.mealOutbound.miles = x.MILES;
            this.mealOutbound.bkgStatus = x.BOOKING_STATUS;
          }
        } else if (x.SSR_TYPE == 2 && x.SEGMENT_REF_NO == 2) {
          if (x.SSR_CODE != null && x.SSR_MEMBER_BENEFIT_DETAILID != null && x.SSR_EXTERNAL_DETAILID != null) {
            this.baggageOutbound.amount = x.SSR_AMOUNT = 0;
            this.baggageOutbound.miles = x.MILES = 0;
          } else {
            this.baggageOutbound.description = x.DESCRIPTION;
            this.baggageOutbound.amount = x.SSR_AMOUNT;
            this.baggageOutbound.miles = x.MILES;
            this.baggageOutbound.bkgStatus = x.BOOKING_STATUS;
          }
        } else if (x.SSR_TYPE == 3 && x.SEGMENT_REF_NO == 2) {
          if (x.SSR_CODE != null && x.SSR_MEMBER_BENEFIT_DETAILID != null && x.SSR_EXTERNAL_DETAILID != null) {
            this.seatOutbound.amount = x.SSR_AMOUNT = 0;
            this.seatOutbound.miles = x.MILES = 0;
          } else {
            this.seatOutbound.description = x.DESCRIPTION;
            this.seatOutbound.amount = x.SSR_AMOUNT;
            this.seatOutbound.miles = x.MILES;
            this.seatOutbound.bkgStatus = x.BOOKING_STATUS;
          }
        } else if (x.SSR_TYPE == 4 && x.SEGMENT_REF_NO == 2) {
          if (x.SSR_CODE != null && x.SSR_MEMBER_BENEFIT_DETAILID != null && x.SSR_EXTERNAL_DETAILID != null) {
            this.loungeOutbound.amount = x.SSR_AMOUNT = 0;
            this.loungeOutbound.miles = x.MILES = 0;
          } else {
            this.loungeOutbound.description = x.DESCRIPTION;
            this.loungeOutbound.amount = x.SSR_AMOUNT;
            this.loungeOutbound.miles = x.MILES;
            this.loungeOutbound.bkgStatus = x.BOOKING_STATUS;
          }
        } else if (x.SSR_TYPE == 0) {

          this.tiInbound.description = x.DESCRIPTION;
          this.tiInbound.amount = x.SSR_AMOUNT;
          this.tiInbound.miles = x.MILES;
          this.tiInbound.bkgStatus = x.BOOKING_STATUS;
          this.tiOutbound.description = x.DESCRIPTION;
          this.tiOutbound.amount = x.SSR_AMOUNT;
          this.tiOutbound.miles = x.MILES;
          this.tiOutbound.bkgStatus = x.BOOKING_STATUS;
        }
        
        // this.LOUNGE_MILES = this.LOUNGE_MILES +  parseInt(this.loungeInbound.miles ? this.loungeInbound.miles : 0) + parseInt(this.loungeOutbound.miles ? this.loungeOutbound.miles : 0)
        // this.MEAL_MILES = this.MEAL_MILES + parseInt(this.mealInbound.miles ? this.mealInbound.miles : 0) + parseInt(this.mealOutbound.miles ? this.mealOutbound.miles : 0)
        // this.BAGGAGE_MILES = this.BAGGAGE_MILES + parseInt(this.baggageInbound.miles ? this.baggageInbound.miles : 0) + parseInt(this.baggageOutbound.miles ? this.baggageOutbound.miles : 0)
        // this.SEAT_MILES = this.SEAT_MILES + parseInt(this.seatInbound.miles ? this.seatInbound.miles : 0) + parseInt(this.seatOutbound.miles ? this.seatOutbound.miles : 0)
        // this.TI_MILES = this.TI_MILES +  parseInt(this.tiInbound.miles ? this.tiInbound.miles : 0) * this.booking_details_info[0].NO_OF_PASSENGER
      });
    }
  }

  refundAncillariesBtn() {
    if (this.ancilaries_details.length > 0) {
      this.ancilaries_details.forEach(x => {
        console.log("this.ancilaries_details###########", x);
        if (x.SSR_TYPE == 1 && x.SEGMENT_REF_NO == 1) {
          this.mealInbound.description = x.DESCRIPTION;
          this.mealInbound.amount = x.SSR_AMOUNT;
          this.mealInbound.miles = x.MILES;
          this.mealInbound.bkgStatus = x.BOOKING_STATUS;
        } else if (x.SSR_TYPE == 2 && x.SEGMENT_REF_NO == 1) {
          this.baggageInbound.description = x.DESCRIPTION;
          this.baggageInbound.amount = x.SSR_AMOUNT;
          this.baggageInbound.miles = x.MILES;
          this.baggageInbound.bkgStatus = x.BOOKING_STATUS;
        } else if (x.SSR_TYPE == 3 && x.SEGMENT_REF_NO == 1) {
          this.seatInbound.description = x.DESCRIPTION;
          this.seatInbound.amount = x.SSR_AMOUNT;
          this.seatInbound.miles = x.MILES;
          this.seatInbound.bkgStatus = x.BOOKING_STATUS;
        } else if (x.SSR_TYPE == 1 && x.SEGMENT_REF_NO == 2) {
          this.mealOutbound.description = x.DESCRIPTION;
          this.mealOutbound.amount = x.SSR_AMOUNT;
          this.mealOutbound.miles = x.MILES;
          this.mealOutbound.bkgStatus = x.BOOKING_STATUS;
        } else if (x.SSR_TYPE == 2 && x.SEGMENT_REF_NO == 2) {
          this.baggageOutbound.description = x.DESCRIPTION;
          this.baggageOutbound.amount = x.SSR_AMOUNT;
          this.baggageOutbound.miles = x.MILES;
          this.baggageOutbound.bkgStatus = x.BOOKING_STATUS;
        } else if (x.SSR_TYPE == 3 && x.SEGMENT_REF_NO == 2) {
          this.seatOutbound.description = x.DESCRIPTION;
          this.seatOutbound.amount = x.SSR_AMOUNT;
          this.seatOutbound.miles = x.MILES;
          this.seatOutbound.bkgStatus = x.BOOKING_STATUS;
        }
        else if (x.SSR_TYPE == 0) {
          this.tiInbound.description = x.DESCRIPTION;
          this.tiInbound.amount = x.SSR_AMOUNT;
          this.tiInbound.miles = x.MILES;
          this.tiInbound.bkgStatus = x.BOOKING_STATUS;
          this.tiOutbound.description = x.DESCRIPTION;
          this.tiOutbound.amount = x.SSR_AMOUNT;
          this.tiOutbound.miles = x.MILES;
          this.tiOutbound.bkgStatus = x.BOOKING_STATUS;
        }
      });
    }
  }

  updateAncillariesInbound(type, segment_type) {
    if (type == "seat" && segment_type == "Inbound") {
      let url = "seatAncillaries";
      let seatInboundData = this.seatInbound;
      seatInboundData["passegerNo"] = this.defaultOne;
      seatInboundData["FB_BOOKING_REF_NO"] = this.FB_BOOKING_REF_NO;
      seatInboundData["segementNo"] = this.selectionTab;
      seatInboundData["bookingStatus"] = 2;
      seatInboundData["USER_ID"] = this.uid;
      seatInboundData["USER_NAME"] = this.fname + ' ' + this.lname;
      if (this.validateData(seatInboundData)) {
        this.vernostService.postData(url, seatInboundData).subscribe(res => {
          if (res[0].status == "Sucess") {
            this.seatInbound.bkgStatus = 2;
            (<HTMLButtonElement>document.getElementById("updateAncilariesMessageBtn")).click();
            //this.ancilaries_details[0].BOOKING_STATUS = 2;
          }
        });
      }
      else {
        (<HTMLButtonElement>document.getElementById("updateAncilariesErrorBtn")).click();
      }
    } else if (type == "meal" && segment_type == "Inbound") {
      let url = "mealAncillaries";
      let mealInboundData = this.mealInbound;
      mealInboundData["passegerNo"] = this.defaultOne;
      mealInboundData["FB_BOOKING_REF_NO"] = this.FB_BOOKING_REF_NO;
      mealInboundData["segementNo"] = this.selectionTab;
      mealInboundData["bookingStatus"] = 2;
      mealInboundData["USER_ID"] = this.uid;
      mealInboundData["USER_NAME"] = this.fname + ' ' + this.lname;
      if (this.validateData(mealInboundData)) {
        this.vernostService.postData(url, mealInboundData).subscribe(res => {
          if (res[0].status == "Sucess") {
            this.mealInbound.bkgStatus = 2;
            (<HTMLButtonElement>document.getElementById("updateAncilariesMessageBtn")).click();
            //this.ancilaries_details[0].BOOKING_STATUS = 2;
          }
        });
      }
      else {
        (<HTMLButtonElement>document.getElementById("updateAncilariesErrorBtn")).click();
      }
    } else if (type == "baggage" && segment_type == "Inbound") {
      let url = "baggageAncillaries";
      let baggaeInboundData = this.baggageInbound;
      baggaeInboundData["passegerNo"] = this.defaultOne;
      baggaeInboundData["FB_BOOKING_REF_NO"] = this.FB_BOOKING_REF_NO;
      baggaeInboundData["segementNo"] = this.selectionTab;
      baggaeInboundData["bookingStatus"] = 2;
      baggaeInboundData["USER_ID"] = this.uid;
      baggaeInboundData["USER_NAME"] = this.fname + ' ' + this.lname;
      if (this.validateData(baggaeInboundData)) {
        this.vernostService.postData(url, baggaeInboundData).subscribe(res => {
          if (res[0].status == "Sucess") {
            this.baggageInbound.bkgStatus = 2;
            (<HTMLButtonElement>document.getElementById("updateAncilariesMessageBtn")).click();
            //this.ancilaries_details[0].BOOKING_STATUS = 2;
          }
        });
      }
      else {
        (<HTMLButtonElement>document.getElementById("updateAncilariesErrorBtn")).click();
      }
    } else if (type == "zeroCancel" && segment_type == "Inbound") {
      let url = "zeroCancelAncillaries";
      let zeroCancelInboundData = this.zcInbound;
      zeroCancelInboundData["passegerNo"] = this.defaultOne;
      zeroCancelInboundData["FB_BOOKING_REF_NO"] = this.FB_BOOKING_REF_NO;
      zeroCancelInboundData["segementNo"] = this.selectionTab;
      zeroCancelInboundData["bookingStatus"] = 2;
      zeroCancelInboundData["USER_ID"] = this.uid;
      zeroCancelInboundData["USER_NAME"] = this.fname + ' ' + this.lname;
      if (this.validateData(zeroCancelInboundData)) {
        this.vernostService.postData(url, zeroCancelInboundData).subscribe(res => {
          if (res[0].status == "Sucess") {
            (<HTMLButtonElement>document.getElementById("updateAncilariesMessageBtn")).click();
            //this.ancilaries_details[0].BOOKING_STATUS = 2;
          }
        });
      }
      else {
        (<HTMLButtonElement>document.getElementById("updateAncilariesErrorBtn")).click();
      }
    } else if (type == "travel" && segment_type == "Inbound") {
      let url = "travelAncillaries";
      let travelInboundData = this.tiInbound;
      travelInboundData["passegerNo"] = this.defaultOne;
      travelInboundData["FB_BOOKING_REF_NO"] = this.FB_BOOKING_REF_NO;
      travelInboundData["segementNo"] = this.selectionTab;
      travelInboundData["bookingStatus"] = 2;
      travelInboundData["USER_ID"] = this.uid;
      travelInboundData["USER_NAME"] = this.fname + ' ' + this.lname;
      if (this.validateData(travelInboundData)) {
        this.vernostService.postData(url, travelInboundData).subscribe(res => {
          if (res[0].status == "Sucess") {
            this.tiInbound.bkgStatus = 2;
            (<HTMLButtonElement>document.getElementById("updateAncilariesMessageBtn")).click();
            //this.ancilaries_details[0].BOOKING_STATUS = 2;
          }
        });
      }
      else {
        (<HTMLButtonElement>document.getElementById("updateAncilariesErrorBtn")).click();
      }
    }
  }

  updateAncillariesOutbound(type, segment_type) {
    if (type == "seat" && segment_type == "Outbound") {
      let url = "seatAncillaries";
      let seatOutboundData = this.seatOutbound;
      seatOutboundData["passegerNo"] = this.defaultTwo;
      seatOutboundData["FB_BOOKING_REF_NO"] = this.FB_BOOKING_REF_NO;
      seatOutboundData["segementNo"] = this.selectionTab;
      seatOutboundData["USER_ID"] = this.uid;
      seatOutboundData["USER_NAME"] = this.fname + ' ' + this.lname;
      // data["bookingStatus"] = 2;
      if (this.validateData(seatOutboundData)) {
        this.vernostService.postData(url, seatOutboundData).subscribe(res => {
          if (res[0].status == "Sucess") {
            this.seatOutbound.bkgStatus = 2;
            (<HTMLButtonElement>document.getElementById("updateAncilariesMessageBtn")).click();
            //this.ancilaries_details[0].BOOKING_STATUS = 2;
          }
        });
      }
      else {
        (<HTMLButtonElement>document.getElementById("updateAncilariesErrorBtn")).click();
      }
    } else if (type == "meal" && segment_type == "Outbound") {
      let url = "mealAncillaries";
      let mealOutboundData = this.mealOutbound;
      mealOutboundData["passegerNo"] = this.defaultTwo;
      mealOutboundData["FB_BOOKING_REF_NO"] = this.FB_BOOKING_REF_NO;
      mealOutboundData["segementNo"] = this.selectionTab;
      mealOutboundData["bookingStatus"] = 2;
      mealOutboundData["USER_ID"] = this.uid;
      mealOutboundData["USER_NAME"] = this.fname + ' ' + this.lname;
      if (this.validateData(mealOutboundData)) {
        this.vernostService.postData(url, mealOutboundData).subscribe(res => {
          if (res[0].status == "Sucess") {
            this.mealOutbound.bkgStatus = 2;
            (<HTMLButtonElement>document.getElementById("updateAncilariesMessageBtn")).click();
            //this.ancilaries_details[0].BOOKING_STATUS = 2;
          }
        });
      }
      else {
        (<HTMLButtonElement>document.getElementById("updateAncilariesErrorBtn")).click();
      }
    } else if (type == "baggage" && segment_type == "Outbound") {
      let url = "baggageAncillaries";
      let baggageOutboundData = this.baggageOutbound;
      baggageOutboundData["passegerNo"] = this.defaultTwo;
      baggageOutboundData["FB_BOOKING_REF_NO"] = this.FB_BOOKING_REF_NO;
      baggageOutboundData["segementNo"] = this.selectionTab;
      baggageOutboundData["bookingStatus"] = 2;
      baggageOutboundData["USER_ID"] = this.uid;
      baggageOutboundData["USER_NAME"] = this.fname + ' ' + this.lname;
      if (this.validateData(baggageOutboundData)) {
        this.vernostService.postData(url, baggageOutboundData).subscribe(res => {
          if (res[0].status == "Sucess") {
            this.baggageOutbound.bkgStatus = 2;
            (<HTMLButtonElement>document.getElementById("updateAncilariesMessageBtn")).click();
            //this.ancilaries_details[0].BOOKING_STATUS = 2;
          }
        });
      }
      else {
        (<HTMLButtonElement>document.getElementById("updateAncilariesErrorBtn")).click();
      }
    } else if (type == "zeroCancel" && segment_type == "Outbound") {
      let url = "zeroCancelAncillaries";
      let zeroCanelOutboundData = this.zcOutbound;
      zeroCanelOutboundData["passegerNo"] = this.defaultTwo;
      zeroCanelOutboundData["FB_BOOKING_REF_NO"] = this.FB_BOOKING_REF_NO;
      zeroCanelOutboundData["segementNo"] = this.selectionTab;
      zeroCanelOutboundData["bookingStatus"] = 2;
      zeroCanelOutboundData["USER_ID"] = this.uid;
      zeroCanelOutboundData["USER_NAME"] = this.fname + ' ' + this.lname;
      if (this.validateData(zeroCanelOutboundData)) {
        this.vernostService.postData(url, zeroCanelOutboundData).subscribe(res => {
          if (res[0].status == "Sucess") {
            (<HTMLButtonElement>document.getElementById("updateAncilariesMessageBtn")).click();
            //this.ancilaries_details[0].BOOKING_STATUS = 2;
          }
        });
      }
      else {
        (<HTMLButtonElement>document.getElementById("updateAncilariesErrorBtn")).click();
      }
    } else if (type == "travel" && segment_type == "Outbound") {
      let url = "travelAncillaries";
      let travelOutboundData = this.tiOutbound;
      travelOutboundData["passegerNo"] = this.defaultTwo;
      travelOutboundData["FB_BOOKING_REF_NO"] = this.FB_BOOKING_REF_NO;
      travelOutboundData["segementNo"] = this.selectionTab;
      travelOutboundData["bookingStatus"] = 2;
      travelOutboundData["USER_ID"] = this.uid;
      travelOutboundData["USER_NAME"] = this.fname + ' ' + this.lname;
      if (this.validateData(travelOutboundData)) {
        this.vernostService.postData(url, travelOutboundData).subscribe(res => {
          if (res[0].status == "Sucess") {
            this.tiOutbound.bkgStatus = 2;
            (<HTMLButtonElement>document.getElementById("updateAncilariesMessageBtn")).click();
            //this.ancilaries_details[0].BOOKING_STATUS = 2;
          }
        });
      }
      else {
        (<HTMLButtonElement>document.getElementById("updateAncilariesErrorBtn")).click();
      }
    }
  }

  refundAncillariesInbound(type, segment_type) {
    if (type == "seat" && segment_type == "Inbound") {
      let url = "seatAncillaries";
      let seatRefundInbData = this.seatInbound;
      seatRefundInbData["passegerNo"] = this.defaultOne;
      seatRefundInbData["FB_BOOKING_REF_NO"] = this.FB_BOOKING_REF_NO;
      seatRefundInbData["segementNo"] = this.selectionTab;
      seatRefundInbData["bookingStatus"] = 4;
      seatRefundInbData["USER_ID"] = this.uid;
      seatRefundInbData["USER_NAME"] = this.fname + ' ' + this.lname;
      if (this.validateData(seatRefundInbData)) {
        this.vernostService.postData(url, seatRefundInbData).subscribe(res => {
          if (res[0].status == "Sucess") {
            this.seatInbound.bkgStatus = 4;
            (<HTMLButtonElement>document.getElementById("updateAncilariesMessageBtn")).click();
            //this.ancilaries_details[0].BOOKING_STATUS = 2;
          }
        });
      }
      else {
        (<HTMLButtonElement>document.getElementById("updateAncilariesErrorBtn")).click();
      }
    } else if (type == "meal" && segment_type == "Inbound") {
      let url = "mealAncillaries";
      let mealRefundInbData = this.mealInbound;
      mealRefundInbData["passegerNo"] = this.defaultOne;
      mealRefundInbData["FB_BOOKING_REF_NO"] = this.FB_BOOKING_REF_NO;
      mealRefundInbData["segementNo"] = this.selectionTab;
      mealRefundInbData["bookingStatus"] = 4;
      mealRefundInbData["USER_ID"] = this.uid;
      mealRefundInbData["USER_NAME"] = this.fname + ' ' + this.lname;
      if (this.validateData(mealRefundInbData)) {
        this.vernostService.postData(url, mealRefundInbData).subscribe(res => {
          if (res[0].status == "Sucess") {
            this.mealInbound.bkgStatus = 4;
            (<HTMLButtonElement>document.getElementById("updateAncilariesMessageBtn")).click();
            //this.ancilaries_details[0].BOOKING_STATUS = 2;
          }
        });
      }
      else {
        (<HTMLButtonElement>document.getElementById("updateAncilariesErrorBtn")).click();
      }
    } else if (type == "baggage" && segment_type == "Inbound") {
      let url = "baggageAncillaries";
      let baggageRefundInbData = this.baggageInbound;
      baggageRefundInbData["passegerNo"] = this.defaultOne;
      baggageRefundInbData["FB_BOOKING_REF_NO"] = this.FB_BOOKING_REF_NO;
      baggageRefundInbData["segementNo"] = this.selectionTab;
      baggageRefundInbData["bookingStatus"] = 4;
      baggageRefundInbData["USER_ID"] = this.uid;
      baggageRefundInbData["USER_NAME"] = this.fname + ' ' + this.lname;
      if (this.validateData(baggageRefundInbData)) {
        this.vernostService.postData(url, baggageRefundInbData).subscribe(res => {
          if (res[0].status == "Sucess") {
            this.baggageInbound.bkgStatus = 4;
            (<HTMLButtonElement>document.getElementById("updateAncilariesMessageBtn")).click();
            //this.ancilaries_details[0].BOOKING_STATUS = 2;
          }
        });
      }
      else {
        (<HTMLButtonElement>document.getElementById("updateAncilariesErrorBtn")).click();
      }
    } else if (type == "zeroCancel" && segment_type == "Inbound") {
      let url = "zeroCancelAncillaries";
      let zeroCancelRefundInbData = this.zcInbound;
      zeroCancelRefundInbData["passegerNo"] = this.defaultOne;
      zeroCancelRefundInbData["FB_BOOKING_REF_NO"] = this.FB_BOOKING_REF_NO;
      zeroCancelRefundInbData["segementNo"] = this.selectionTab;
      zeroCancelRefundInbData["bookingStatus"] = 4;
      zeroCancelRefundInbData["USER_ID"] = this.uid;
      zeroCancelRefundInbData["USER_NAME"] = this.fname + ' ' + this.lname;
      if (this.validateData(zeroCancelRefundInbData)) {
        this.vernostService.postData(url, zeroCancelRefundInbData).subscribe(res => {
          if (res[0].status == "Sucess") {
            (<HTMLButtonElement>document.getElementById("updateAncilariesMessageBtn")).click();
            //this.ancilaries_details[0].BOOKING_STATUS = 2;
          }
        });
      }
      else {
        (<HTMLButtonElement>document.getElementById("updateAncilariesErrorBtn")).click();
      }
    } else if (type == "travel" && segment_type == "Inbound") {
      let url = "travelAncillaries";
      let travelRefundInbData = this.tiInbound;
      travelRefundInbData["passegerNo"] = this.defaultOne;
      travelRefundInbData["FB_BOOKING_REF_NO"] = this.FB_BOOKING_REF_NO;
      travelRefundInbData["segementNo"] = this.selectionTab;
      travelRefundInbData["bookingStatus"] = 4;
      travelRefundInbData["USER_ID"] = this.uid;
      travelRefundInbData["USER_NAME"] = this.fname + ' ' + this.lname;
      if (this.validateData(travelRefundInbData)) {
        this.vernostService.postData(url, travelRefundInbData).subscribe(res => {
          if (res[0].status == "Sucess") {
            this.tiInbound.bkgStatus = 4;
            (<HTMLButtonElement>document.getElementById("updateAncilariesMessageBtn")).click();
            //this.ancilaries_details[0].BOOKING_STATUS = 2;
          }
        });
      }
      else {
        (<HTMLButtonElement>document.getElementById("updateAncilariesErrorBtn")).click();
      }
    }
  }

  refundAncillariesOutbound(type, segment_type) {
    if (type == "seat" && segment_type == "Outbound") {
      let url = "seatAncillaries";
      let data = this.seatOutbound;
      data["passegerNo"] = this.defaultTwo;
      data["FB_BOOKING_REF_NO"] = this.FB_BOOKING_REF_NO;
      data["segementNo"] = this.selectionTab;
      data["bookingStatus"] = 4;
      data["USER_ID"] = this.uid;
      data["USER_NAME"] = this.fname + ' ' + this.lname;
      if (this.validateData(data)) {
        this.vernostService.postData(url, data).subscribe(res => {
          if (res[0].status == "Sucess") {
            this.seatOutbound.bkgStatus = 4;
            (<HTMLButtonElement>document.getElementById("updateAncilariesMessageBtn")).click();
            //this.ancilaries_details[0].BOOKING_STATUS = 2;
          }
        });
      }
      else {
        (<HTMLButtonElement>document.getElementById("updateAncilariesErrorBtn")).click();
      }
    } else if (type == "meal" && segment_type == "Outbound") {
      let url = "mealAncillaries";
      let data = this.mealOutbound;
      data["passegerNo"] = this.defaultTwo;
      data["FB_BOOKING_REF_NO"] = this.FB_BOOKING_REF_NO;
      data["segementNo"] = this.selectionTab;
      data["bookingStatus"] = 4;
      data["USER_ID"] = this.uid;
      data["USER_NAME"] = this.fname + ' ' + this.lname;
      if (this.validateData(data)) {
        this.vernostService.postData(url, data).subscribe(res => {
          if (res[0].status == "Sucess") {
            this.mealOutbound.bkgStatus = 4;
            (<HTMLButtonElement>document.getElementById("updateAncilariesMessageBtn")).click();
            //this.ancilaries_details[0].BOOKING_STATUS = 2;
          }
        });
      }
      else {
        (<HTMLButtonElement>document.getElementById("updateAncilariesErrorBtn")).click();
      }
    } else if (type == "baggage" && segment_type == "Outbound") {
      let url = "baggageAncillaries";
      let data = this.baggageOutbound;
      data["passegerNo"] = this.defaultTwo;
      data["FB_BOOKING_REF_NO"] = this.FB_BOOKING_REF_NO;
      data["segementNo"] = this.selectionTab;
      data["bookingStatus"] = 4;
      data["USER_ID"] = this.uid;
      data["USER_NAME"] = this.fname + ' ' + this.lname;
      if (this.validateData(data)) {
        this.vernostService.postData(url, data).subscribe(res => {
          if (res[0].status == "Sucess") {
            this.baggageOutbound.bkgStatus = 4;
            (<HTMLButtonElement>document.getElementById("updateAncilariesMessageBtn")).click();
            //this.ancilaries_details[0].BOOKING_STATUS = 2;
          }
        });
      }
      else {
        (<HTMLButtonElement>document.getElementById("updateAncilariesErrorBtn")).click();
      }
    } else if (type == "zeroCancel" && segment_type == "Outbound") {
      let url = "zeroCancelAncillaries";
      let data = this.zcOutbound;
      data["passegerNo"] = this.defaultTwo;
      data["FB_BOOKING_REF_NO"] = this.FB_BOOKING_REF_NO;
      data["segementNo"] = this.selectionTab;
      data["bookingStatus"] = 4;
      data["USER_ID"] = this.uid;
      data["USER_NAME"] = this.fname + ' ' + this.lname;
      if (this.validateData(data)) {
        this.vernostService.postData(url, data).subscribe(res => {
          if (res[0].status == "Sucess") {
            (<HTMLButtonElement>document.getElementById("updateAncilariesMessageBtn")).click();
            //this.ancilaries_details[0].BOOKING_STATUS = 2;
          }
        });
      }
      else {
        (<HTMLButtonElement>document.getElementById("updateAncilariesErrorBtn")).click();
      }
    } else if (type == "travel" && segment_type == "Outbound") {
      let url = "travelAncillaries";
      let data = this.tiOutbound;
      data["passegerNo"] = this.defaultTwo;
      data["FB_BOOKING_REF_NO"] = this.FB_BOOKING_REF_NO;
      data["segementNo"] = this.selectionTab;
      data["bookingStatus"] = 4;
      data["USER_ID"] = this.uid;
      data["USER_NAME"] = this.fname + ' ' + this.lname;
      if (this.validateData(data)) {
        this.vernostService.postData(url, data).subscribe(res => {
          if (res[0].status == "Sucess") {
            this.tiOutbound.bkgStatus = 4;
            (<HTMLButtonElement>document.getElementById("updateAncilariesMessageBtn")).click();
            //this.ancilaries_details[0].BOOKING_STATUS = 2;
          }
        });
      }
      else {
        (<HTMLButtonElement>document.getElementById("updateAncilariesErrorBtn")).click();
      }
    }
  }

  disableUpdateIn() {
    this.updateAncilariesIn = false;
  }

  disableUpdateOut() {
    this.updateAncilariesOut = false;
  }

  disableRefundIn() {
    this.refundAncilariesIn = false;
  }

  disableRefundOut() {
    this.refundAncilariesOut = false;
  }

  closeAncillaries() {
    this.seatInbound = { description: "", amount: "", miles: "" };
    this.mealInbound = { description: "", amount: "", miles: "" };
    this.baggageInbound = { description: "", amount: "", miles: "" };
    this.zcInbound = { description: "", amount: "", miles: "" };
    this.tiInbound = { description: "", amount: "", miles: "" };
    this.seatOutbound = { description: "", amount: "", miles: "" };
    this.mealOutbound = { description: "", amount: "", miles: "" };
    this.baggageOutbound = { description: "", amount: "", miles: "" };
    this.zcOutbound = { description: "", amount: "", miles: "" };
    this.tiOutbound = { description: "", amount: "", miles: "" };
  }
  sendMail() {
    this.updateBookingMail(this.booking_details_info[0].ORDER_ID)
    var url = "sendconfirmmail";
    var req = {
      "ORDER_ID": this.booking_details_info[0].ORDER_ID,
      "FB_BOOKING_REF_NO": this.FB_BOOKING_REF_NO,
      "USER_ID": this.uid,
      "USER_NAME": this.fname + " " + this.lname

    }
    var all_confirm = true;
    if (this.booking_details[0].SUPPLIER_NAME != 'TBO') {
      for (var i = 0; i < this.ancilaries_details.length; i++) {
        if (this.ancilaries_details[i]["BOOKING_STATUS"] != "2" && this.ancilaries_details[i]["BOOKING_STATUS"] != "4") {
          console.log("confrm flase:", this.ancilaries_details[i])
          all_confirm = false;
        }
      }
    }
    console.log("all_confirm:", all_confirm)
    if (all_confirm) {
      this.vernostService.getEmailSentStatus(req).subscribe(emailsentres => {
        console.log("mailsentdata:", emailsentres)
        if (emailsentres[0]["status"] == "success") {
          this.showConfirmMsg("Confirm Mail", "Confirmation Email has already been sent. Do you want to resend ?")
        } else {
          this.vernostService.postData(url, req).subscribe(res => {
            console.log("res", res);
            if (res["email"] == "true") {
              this.showCustomMsg("Confirm Mail", "Email sent successfully")
              this.IS_EMAIL_SENT = 1;
            }
            else {
              if (res["msg"] == "already sent") {
                this.showCustomMsg("Confirm Mail", "Email has already been sent")
              }
              else {
                this.showCustomMsg("Confirm Mail", "Email not sent")
              }
            }
          })
        }
      })

    }
    else {
      this.showCustomMsg("Confirm Mail", "You cannot send Email unless all ancillaries are confirmed")
    }    
  }

  sendConfirmMail() {
    var url = "sendconfirmmail";
    var req = {
      "ORDER_ID": this.booking_details_info[0].ORDER_ID,
      "FB_BOOKING_REF_NO": this.FB_BOOKING_REF_NO,
      "USER_ID": this.uid,
      "USER_NAME": this.fname + " " + this.lname
    }
    this.vernostService.postData(url, req).subscribe(res => {
      console.log("res", res);
      console.log(res["email"] == "true")
      if (res["email"] == "true") {
        this.showCustomMsg("Confirm Mail", "Email sent successfully")
      } else if (res[0].status == "Failed" && res[0].message == "Booking Not Confirmed") {
        this.showCustomMsg("Confirm Mail", "Email can only be sent for confirmed bookings");
      }
      else {
        // if(res["msg"] == "already sent"){
        //   this.showCustomMsg("Confirm Mail","Email has already been sent")
        // }
        // else{
        this.showCustomMsg("Confirm Mail", "Email not sent");
        // }
      }
    })
  }
  validateData(data) {
    var regex = /^[0-9]+(\.[0-9]+)?$/;
    return (data.description != null && data.description != undefined && data.description.trim() != "") &&
      (data.amount != null && data.amount != undefined && regex.test(data.amount)) &&
      (data.miles != null && data.miles != undefined && regex.test(data.miles));
  }

  legSelection(segment_ref_no, leg_no) {
    this.selectionSeg = segment_ref_no;
    this.selectionLeg = leg_no;//(this.selectionSeg == 1) ? leg_no : (leg_no % segment_ref_no) + 1;
    console.log("this.selectionSeg:", this.selectionSeg, ",leg:", leg_no, ",selectionLeg:", this.selectionLeg)
    this.onPaxChangeDyn(this.selectionPax);
  }

  activateFirstTab() {
    var first = true;
    this.leg_tabs = {};
    for (var sector of this.Leg_details) {
      this.leg_tabs[sector["ORIGIN"] + sector["DESTINATION"]] = {
        "ORIGIN": sector["ORIGIN"],
        "DESTINATION": sector["DESTINATION"],
        "SEGMENT_REF_NO": sector["SEGMENT_REF_NO"],
        "LEG_NO": sector["LEG_ORDER"],
        "tabactive": first,
        "editable": false,
        "showEdit": sector["showEdit"]
      };
      first = false;
    }
    console.log("legs:", this.leg_tabs)
  }

  onPaxChangeDyn(value) {
    console.log("onPaxChange:", value);
    if (value) {
      this.selectionPax = value;
      this.current_ancilaries_details = [];
      if (this.ancilaries_details.length > 0) {
        for (var i = 0; i < this.ancilaries_details.length; i++) {
          var data = this.ancilaries_details[i];
          // for (let data of this.ancilaries_details) {

          if (
            (data.SEGMENT_REF_NO == this.selectionSeg || data.SSR_TYPE == "0") &&
            (data.LEG_NO == 0 || data.LEG_NO == this.selectionLeg) &&
            data.PASSENGER_NO == value
          ) {
            this.showAncilariesDiv = true;
            data["index"] = i;
            this.ANCILARIES_STATUS = data;
            this.current_ancilaries_details.push(data)
            console.log(this.selectionTab, "data.PASSENGER_NO:", data.PASSENGER_NO, ",this.ANCILARIES_STATUS:", this.ANCILARIES_STATUS)
          }
        }
      }
      console.log("current_ancilaries_details:", this.current_ancilaries_details)
      this.screen_ancill_data = {};
      for (var key in this.obj) {
        // console.log("key:",key)
        this.screen_ancill_data[key] = {
          "description": "", "amount": "",
          "miles": "", "bkgStatus": undefined,
          "leg": "", "segment": ""
        }
      }
      console.log("screen_ancill_data:", this.screen_ancill_data)
      this.updateAncillariesData();
    }
  }
  updateAncillariesData() {
    this.curr_all_disabled = true;
    if (this.current_ancilaries_details.length > 0) {
      this.current_ancilaries_details.forEach(x => {
        console.log("this.ancilaries_details###########", x);

        this.screen_ancill_data[x.SSR_TYPE] = {
          "description": x.DESCRIPTION, "amount": x.SSR_AMOUNT,
          "miles": x.SSR_EXTERNAL_DETAILID != null ? 0 : x.MILES, "bkgStatus": x.BOOKING_STATUS,
          "leg": x.LEG_NO, "segment": x.SEGMENT_REF_NO,
          "index": x["index"]
        }
        if (x.BOOKING_STATUS != 2 && x.BOOKING_STATUS != undefined) {
          this.curr_all_disabled = false;
        }
      });
      console.log("this.screen_ancill_data:", this.screen_ancill_data)
    }
  }
  updateAncillariesDataDB(ssr_type, segment, leg) {


    let url = this.obj[ssr_type] + "Ancillaries";
    let data = this.screen_ancill_data[ssr_type];
    data["passegerNo"] = this.selectionPax;
    data["FB_BOOKING_REF_NO"] = this.FB_BOOKING_REF_NO;
    data["segementNo"] = segment;
    data["legNo"] = (leg > 1) ? (leg % segment) + 1 : 1;
    data["bookingStatus"] = this.update_refund_flag ? 2 : 4;
    data["jp_no"] = this.booking_details_info[0].JP_NUMBER;
    data["ORDER_ID"] = this.booking_details_info[0].ORDER_ID;

    data["SSR_EXTERNAL_DETAILID"] = this.ancilaries_details[this.screen_ancill_data[ssr_type].index]["SSR_EXTERNAL_DETAILID"];
    data["SSR_MEMBER_BENEFIT_DETAILID"] = this.ancilaries_details[this.screen_ancill_data[ssr_type].index]["SSR_MEMBER_BENEFIT_DETAILID"];

    data["USER_ID"] = this.uid;
    data["USER_NAME"] = this.fname + ' ' + this.lname;


    console.log("data:", data);

    // if(this.validateData(data)){
    if (ssr_type != 0 || this.validateData(data) || !this.update_refund_flag) {
      this.vernostService.postData(url, data).subscribe(res => {
        console.log(JSON.stringify(res));
        if (res != undefined && res[0] != undefined && res[0].status == "Sucess") {
          this.screen_ancill_data[ssr_type].bkgStatus = data["bookingStatus"];
          this.ancilaries_details[this.screen_ancill_data[ssr_type].index]["BOOKING_STATUS"] = data["bookingStatus"];
          this.ancilaries_details[this.screen_ancill_data[ssr_type].index]["DESCRIPTION"] = data["description"];
          this.ancilaries_details[this.screen_ancill_data[ssr_type].index]["MILES"] = data["miles"];
          this.ancilaries_details[this.screen_ancill_data[ssr_type].index]["SSR_AMOUNT"] = data["amount"];

          if (ssr_type == 4 && this.update_refund_flag && res[0].service_resp && res[0].service_resp.ResponseMessage != undefined) {
            //res[0].service_resp
            this.showCustomMsg("Update Status", res[0].service_resp.ResponseMessage);
          }
          else {
            (<HTMLButtonElement>document.getElementById("updateAncilariesMessageBtn")).click();
          }
          //this.ancilaries_details[0].BOOKING_STATUS = 2;
        } else if (res != undefined && res[0] != undefined && res[0].status == "CRIS_DOWN") {
          this.screen_ancill_data[ssr_type].bkgStatus = 1;
          this.ancilaries_details[this.screen_ancill_data[ssr_type].index]["BOOKING_STATUS"] = 1;
          this.showCustomMsg("Update Status", "Something went wrong! Please try again after some time.");
        }
        else {
          this.screen_ancill_data[ssr_type].bkgStatus = 4;
          this.ancilaries_details[this.screen_ancill_data[ssr_type].index]["BOOKING_STATUS"] = 4;
          this.showCustomMsg("Update Status", "Data not updated");
        }
      });
    }
    else {
      (<HTMLButtonElement>document.getElementById("updateAncilariesErrorBtn")).click();
    }
  }
  updateAncillariesNew() {
    this.update_refund_flag = true;
    console.log(" this.Leg_details this.Leg_details", this.Leg_details)
    for (var sector of this.Leg_details) {
      this.leg_tabs[sector["ORIGIN"] + sector["DESTINATION"]]["editable"] = false
    }
  }
  refundAncillariesNew() {
    this.update_refund_flag = false;
    for (var sector of this.Leg_details) {
      this.leg_tabs[sector["ORIGIN"] + sector["DESTINATION"]]["editable"] = false
    }
  }
  showDisabledMsg() {
    if (this.all_confirm_status_obj[0] != true && this.all_confirm_status_obj[1] != true) {
      this.showCustomMsg("Update ancillaries", " You cannot make any more changes since all ancillaries are confirmed")
    }
  }
  getAllConfirm() {
    var all_confirm = true;
    for (var i = 0; i < this.ancilaries_details.length; i++) {
      this.all_confirm_status_obj[this.ancilaries_details[i]["BOOKING_STATUS"]] = true;

      // if(this.ancilaries_details[i]["BOOKING_STATUS"]!="2" && this.ancilaries_details[i]["BOOKING_STATUS"]!="4"){
      //   console.log("confrm flase:",this.ancilaries_details[i])
      //   all_confirm = false;
      // }
    }
    console.log("all_confirm_status_obj:", this.all_confirm_status_obj)
    // this.all_confirm_status=all_confirm;

    if (this.all_confirm_status_obj[0] == true || this.all_confirm_status_obj[1] == true) {
      this.all_confirm_status = "Pending"
    }
    else if (this.all_confirm_status_obj[2] == true) {
      this.all_confirm_status = "Confirmed"
    }
    else if (this.all_confirm_status_obj[4] == true) {
      this.all_confirm_status = "Failed"
    }
    else if (this.all_confirm_status_obj[5] == true) {
      this.all_confirm_status = "Cancelled"
    }
    else if (this.all_confirm_status_obj[6] == true) {
      this.all_confirm_status = "Reversed"
    }
    else if (this.all_confirm_status_obj[7] == true) {
      this.all_confirm_status = "Cancel Requested"
    }
    else if (this.all_confirm_status_obj[8] == true) {
      this.all_confirm_status = "Cancelled"
    }
    else {
      this.all_confirm_status = "Not Opted"
    }
  }
  showCustomMsg(custom_header, custom_msg) {
    this.custom_header = custom_header;
    this.custom_msg = custom_msg;
    (<HTMLButtonElement>document.getElementById("updateCustomMsgBtn")).click();
  }
  showConfirmMsg(custom_header, custom_msg) {
    this.custom_header = custom_header;
    this.custom_msg = custom_msg;
    (<HTMLButtonElement>document.getElementById("updateConfirmMsgBtn")).click();
  }
  objectkeys(obj) {
    return Object.keys(obj);
  }



  cancelStatus() {
    var check_count = 0;
    var checkbox = document.getElementsByClassName('check');
    console.log("=====", checkbox[1]);
    for (var i = 0; i < checkbox.length; i++) {
      if ((checkbox[i] as HTMLInputElement).checked == true) {
        check_count++;
        (checkbox[i] as HTMLInputElement).disabled = true;
      }
    }

    //console.log("::::::::called::::::::")
    var orderdata = {
      "ORDER_ID": this.booking_ref,
      "FB_BOOKING_REF_NO": this.FB_BOOKING_REF_NO,
      "UID": this.uid,
      "USER_NAME": this.fname + " " + this.lname,
      "dateTime": new Date()
    }

    console.log(this.canceldetails);
    var err = document.getElementById('errs') as HTMLElement;
    err.innerHTML = "cancel success";
    this.canceldetails['OrderData'] = orderdata;
    this.canceldetails['canceled_count'] = check_count;
    console.log("checked_count------->", check_count);

    this.vernostService.CancelStatus(this.canceldetails).subscribe(result => {
      console.log("result:::::", result);

      if (result['status'] === "true") {
        if (result['CancelStatus'] == "Full_cancelled") {
          (document.getElementById("cancel") as HTMLElement).style.display = "none";
        }
        this.canceldetails['segment0'] = {};
        this.canceldetails['segment1'] = {};
        delete this.canceldetails['OrderData'];
        delete this.canceldetails['canceled_count'];
        (document.getElementById("can") as HTMLButtonElement).click();
        setTimeout(() => {
          err.style.display = 'none';
        }, 7000)
      }
    })
  }

  canceldetails = {
    segment0: {},
    segment1: {}
  }
  ischecked: boolean = false;

  gettingCheckValue(e, segment) {
    var passNo;
    var checkbox;
    console.log("********SEGMENT**********", segment);
    if (this.booking_details[0]['TRAVEL_TYPE'] == "INTERNATIONAL") {
      checkbox = document.getElementsByClassName('check');
      console.log("=====", checkbox.length);
      for (var i = 0; i < checkbox.length; i++) {
        if (checkbox[i].id === e.target.id) {
          (checkbox[i] as HTMLInputElement).checked = e.target.checked;
        }
      }
      if (segment == 'segment0' || segment == 'segment1') {
        if (e.target.checked) {
          passNo = this.pax_detail[parseInt(e.target.id)].PASSENGER_NO;
          this.canceldetails['segment0']['passengerdetail' + e.target.id] = { 'passengerno': passNo, 'segmentNo': this.segment_details[0].SEGMENT_NO };
          console.log('ERRRRRR::::::::', this.segment_details[1], "::::::::", this.segment_details);
          if (this.segment_details[1] != undefined) {
            this.canceldetails['segment1']['passengerdetail' + e.target.id] = { 'passengerno': passNo, 'segmentNo': this.segment_details[1].SEGMENT_NO };
          }
        } else {
          delete this.canceldetails['segment0']['passengerdetail' + e.target.id]
          delete this.canceldetails['segment1']['passengerdetail' + e.target.id]
        }
      }
    } else {
      if (segment == 'segment0') {
        if (e.target.checked) {
          passNo = this.pax_detail[parseInt(e.target.id)].PASSENGER_NO;
          this.canceldetails['segment0']['passengerdetail' + e.target.id] = { 'passengerno': passNo, 'segmentNo': this.segment_details[0].SEGMENT_NO };
        } else {
          delete this.canceldetails['segment0']['passengerdetail' + e.target.id]
        }
      }
      if (segment == 'segment1') {
        if (e.target.checked) {
          passNo = this.pax_detail[parseInt(e.target.id)].PASSENGER_NO;
          this.canceldetails['segment1']['passengerdetail' + e.target.id] = { 'passengerno': passNo, 'segmentNo': this.segment_details[1].SEGMENT_NO };
        } else {
          delete this.canceldetails['segment1']['passengerdetail' + e.target.id]
        }

      }
    }

    var cnt = 0;
    checkbox = document.getElementsByClassName('check');
    console.log("=====", checkbox[1]);
    for (var j = 0; j < checkbox.length; j++) {
      if ((checkbox[j] as HTMLInputElement).checked == true && (checkbox[j] as HTMLInputElement).disabled != true) {
        cnt++;
      }
    }
    if (cnt > 0) {
      (document.getElementById("cnt") as HTMLButtonElement).disabled = false;
    } else {
      (document.getElementById("cnt") as HTMLButtonElement).disabled = true;
    }

    console.log("::::===>", this.canceldetails);
  }

  count = 0;
  canceled_passenger() {
    console.log("***********innn cancelled************");
    var checkbox = document.getElementsByClassName('check');
    console.log("check::::::", checkbox);
    console.log("pppppppp:::::", this.pax_seg_details[this.count]['TICKET_BOOKING_STATUS'], "checkbox_length:::::", checkbox.length);
    for (var i = 0; i < checkbox.length; i++) {
      console.log("count:::::::", this.count, "i :::::::::", i);
      if (this.count < this.pax_seg_details.length) {
        if (i >= checkbox.length / 2) {
          console.log("innnnn=====>", this.count);
          if (this.pax_seg_details[this.count]['TICKET_BOOKING_STATUS'] == 8) {
            (checkbox[i] as HTMLInputElement).checked = true;
            (checkbox[i] as HTMLInputElement).disabled = true;
          }
        } else {
          if (this.pax_seg_details[this.count]['TICKET_BOOKING_STATUS'] == 8) {
            (checkbox[i] as HTMLInputElement).checked = true;
            (checkbox[i] as HTMLInputElement).disabled = true;
          }
        }


      }
      this.count++;
      //console.log("count------------<<<<<",this.count);
    }

  }
  updateBookingMail(oid) {
    return new Promise((resolve, rej) => {
      var data = { oid: oid }
      this.vernostService.updateBookerEmail(data).subscribe((res) => {
        if (res) {
          resolve(true);
        }
        else {
          resolve(false)
        }
      });
    })
  }
  getSupplierId(i) {
    if (this.segment_details.length == 2 && this.segment_details[0].SUPPLIER_CODE == this.segment_details[1].SUPPLIER_CODE
      && this.segment_details[0].SUPPLIER_CODE == "EMT") {
      this.supplierIdList[parseInt(i) + 1].SUPPLIER_ID = this.supplierIdList[i].SUPPLIER_ID;
    }
  }
  historyReload() {
    this.historyLoader = true;
    var data = {
      FB_BOOKING_REF_NO: this.FB_BOOKING_REF_NO,
      pagination: this.p

    }
    this.vernostService.reloadHistory(data).subscribe((res) => {
      this.historyLoader = false;
      if (res[0].status) {
        this.historyList = res[0].data;
        this.totalItems = res[0].count;
        if (this.p == 1) {
          this.sr_number = res[0].count;
        }
      }
    });
  }
  pageCount(count) {
    this.p = count;
    this.historyReload();
    this.sr_number = this.totalItems - ((this.p - 1) * 10);
  }
  bookingstatusupdate() {
    try {
      console.log("--------------------------bookingstatusupdate---------------------", JSON.parse(this.booking_status));
      var booking_status_update = JSON.parse(this.booking_status);
      var arr = [];
      var totalpassengers = booking_status_update.pax_detail
      var adult = 0, child = 0, infant = 0;
      for (let j = 0; j < totalpassengers.length; j++) {
        var passengers = booking_status_update.pax_detail[j].PASSENGER_TYPE;
        if (passengers == "ADT") {
          adult++;
        }
        if (passengers == "CHD") {
          child++;
        }
        if (passengers == "INF") {
          infant++;
        }
      }

      var mobile = booking_status_update.pax_detail[0].MOBILE_NO;
      var mobileno = mobile.slice(2)
      var isdcode = mobile.slice(0, -10)


      for (var i = 0; i < totalpassengers.length; i++) {
        var details = {
          title: booking_status_update.pax_detail[i].TITLE,
          firstName: booking_status_update.pax_detail[i].FIRST_NAME,
          lastName: booking_status_update.pax_detail[i].LAST_NAME,
          isdCode: isdcode,
          mobileNumber: mobileno,
          emailId: booking_status_update.pax_detail[0].EMAIL_ID,
        }
        arr.push(details);
      }

      var basemiles = parseInt(booking_status_update.booking[0].EARN_MILES);

      var total = 0;
      for (var k = 0; k < booking_status_update.ancilaries_details.length; k++) {
        total = total + parseInt(booking_status_update.ancilaries_details[k].MILES);
      }
      var TotalMiles = basemiles + total;

      var comsParameter = {
        itineraryId: booking_status_update.booking[0].ORDER_ID,
        // status: "Confirmed",
        comsOrderId: booking_status_update.booking[0].EXT_ORDER_ID,
        // comsOrderId:"1234",
        tax: String(booking_status_update.booking[0].TOTAL_FEE_N_TAXES),
        totalPayableAmount: String(booking_status_update.booking[0].TOTAL_AMOUNT),
        baseMiles: String(basemiles),
        totalMiles: String(TotalMiles),
        convenienceFee: String(booking_status_update.booking[0].FEES),
        startDate: booking_status_update.booking[0].DEPT_DATE,
        endDate: booking_status_update.booking[0].ARR_DATE,
        // inclusion: inclusiontxt,
        adult: String(adult),
        child: String(child),
        infant: String(infant),
        origin: booking_status_update.Leg_details[0].ORIGIN_CITY,
        destination: booking_status_update.Leg_details[0].DESTINATION_CITY,
        originCode: booking_status_update.Leg_details[0].ORIGIN,
        destinationCode: booking_status_update.Leg_details[0].DESTINATION,

      };
      comsParameter['guestDetails'] = arr
      console.log("------------------comsParameter---------------", comsParameter);
      this.coms_booking_status = comsParameter;

    }
    catch (e) {
      console.log(e)
    }
  }

  onGrowTreeClick() {
    this.isGrowTreeClicked = true;
  }

  sendLoungeMail() {
    const req = {
      "AppRefNo": this.booking_details_info[0].ORDER_ID,
      "ORDER_ID": this.booking_details_info[0].ORDER_ID,
      "FB_BOOKING_REF_NO": this.FB_BOOKING_REF_NO,
      "USER_ID": this.uid,
      "USER_NAME": this.fname + " " + this.lname
    }
   
      this.vernostService.loungeConformationMail(req).subscribe(emailsentres => {
        if(!emailsentres){
          this.showCustomMsg("Lounge Conformation Mail", "Email not sent successfully")
        }
        this.showCustomMsg("Lounge Conformation Mail", "Email sent successfully")
    
      })
  }

  getLoungeData() {
  let getData =  this.ancilaries_details?.find(el=> el.SSR_CODE == 'LOUNGE' && el.BOOKING_STATUS == 2)
  console.log("getData",getData)
  return (getData && this.booking_details[0].BOOKING_STATUS == 2);
  }
}